<template>
  <div >
    <ComponentHeader />
    <main>
      <section class="heroSection">
        <div class="heroWrapper MContainer">
          <div class="heroBody">
            <div>
              <h1>Digital Agency and Marketing</h1>
              <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod
              </p>
            </div>
            <div>
              <img src="../assets/images/Hero_big_img.svg" alt="">
              <img src="../assets/images/call_img.png" alt="">
            </div>
          </div>
        </div>
      </section>
      <section class="pixyzEasysection">
        <div class="pixyzEasywrapper container">
          <div class="pixyzEasybody">
            <h1>How PixYz IT make your life easier</h1>
            <p>Working fast, Proactively and strategically as your trusted Managed Services Provider, we can take away
              the burden of mundane day-to-day tasks, protect your organization from security threats, manage your IT
              infrastructure and workloads, as well as help you to achieve an awful lot more - discover how PixYz IT can
              support you and help you to transfrom your <br> Working fast, Proactively and strategically as your
              trusted Managed Services Provider, we can take away the burden of mundane day-to-day tasks, protect your
              organization from security threats, manage your IT infrastructure and workloads, as well as help you to
              achieve an awful lot more - discover how PixYz IT can support you and help you to transfrom your</p>
          </div>
        </div>
      </section>
      <section class="servicessection">
        <div class="serviceswrapper container">
          <div class="servicesbody">
            <h3>PixYz Agency Services</h3>
            <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt
              ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo
              dolores et ea rebum. Stet clita kasd gubergren, no sea </p>
            <ServicesComponet :ServicesData="servicesData" />
            <div>
              <router-link to="/services"><img src="../assets/images/new_img.svg" alt=""></router-link>
            </div>
          </div>
        </div>
      </section>
      <section class="workLineSection">
        <div class="workLineWrapper container">
          <div class="workLineBody">
            <h3>How We Work?</h3>
            <ul>
              <li>
                <img src="../assets/images/img_idea.png" alt="">
                <div>
                  <h4>First discussion</h4>
                  <p>The first step is to give an overview of the problem we want to solve and / or our needs. If the
                    needs are not properly understood, this will cause the creation of a web application that is
                    designed for these purposes to fail.</p>
                </div>
              </li>
              <li>
                <img src="../assets/images/img_users.png" alt="">
                <div>
                  <h4>Requirements analysis</h4>
                  <p>The goal was to define the goals for implementing the web application. Tasks can be complex, and
                    business logic is often quite complex. At this stage, it is important that these complex tasks can
                    be broken down into more manageable tasks and, therefore, they are easier to implement, verify, and
                    test.</p>
                </div>
              </li>
              <li>
                <img src="../assets/images/img_group.png" alt="">
                <div>
                  <h4>Timeline and Cost Estimation</h4>
                  <p>Experience is a good ally when it comes to making the right
                    assessment. If a similar task was completed earlier, it becomes
                    easier to give an accurate estimate, and time tracking becomes
                    our recommendation. From the previous step, we can collect all
                    the pieces that we are going to collect from end to end. For
                    each task, we analyze its complexity and make a classification.
                  </p>
                </div>
              </li>
            </ul>
            <router-link to="/workLine">FULL STEPS</router-link>
          </div>
        </div>
      </section>
      <section class="texnologySection">
        <div class="texnologyWrapper container">
          <div class="texnologyBody">
            <h3>Specialties and Technologies</h3>
            <p>Our stratigists, designers, architectecs, developers and quality analysts excel in every technology
              powering native, hybrid, cross-
              platform and custom software development.</p>
            <ul>
              <li v-for="item in texnologyData" :key="item.img">
                <img :src="item.img" alt="">
                <p>{{item.title}}</p>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section class="sliderSection">
        <div class="sliderWrapper container">
          <div class="sliderBody">
            <v-carousel height="622" v-model="model" hide-delimiter-background light :show-arrows="false">
              <v-carousel-item v-for="item in dataSliderSection" :key="item">
                <v-sheet color="#f4f6fc">
                  <v-row class="fill-height" align="center" justify="center">
                    <SliderComponent :dataSlider="item" />
                  </v-row>
                </v-sheet>
              </v-carousel-item>
            </v-carousel>
          </div>
        </div>
      </section>
      <section class="postUserSection">
        <div class="postUserWrapper container">
          <div class="postUserBody">
            <div class="post_user_left">
              <h3>Get In Touch</h3>
              <form action="/post" method="post">
                <input required type="text" placeholder="Name">
                <input required type="text" placeholder="Last Name">
                <input required type="email" placeholder="Email">
                <input required type="number" placeholder="Phone/Telegram">
                <select required name="" id="">
                  <option selected value="">
                    I am interested in

                  </option>
                  <option value="">
                    ITEM 1
                  </option>
                  <option value="">
                    ITEM 2
                  </option>
                  <option value="">
                    ITEM 3
                  </option>
                </select>
                <select required name="" id="">
                  <option selected value="">
                    Select Project Budget (in USD)
                  </option>
                  <option value="">
                    ITEM 1
                  </option>
                  <option value="">
                    ITEM 2
                  </option>
                  <option value="">
                    ITEM 3
                  </option>
                </select>
                <textarea required name="" id="" placeholder="About your project" minlength="150" cols="150"
                  rows="10"></textarea>
                <button type="Submit">Submit</button>
              </form>
            </div>
            <div class="post_user_right">
              <h3>Say Hi!</h3>
              <a href="./">info@pixyz.com</a>
              <a href="./">+998 71 645 57 67</a>
              <a href="./">Telegram</a>
            </div>
          </div>
        </div>
      </section>
    </main>
    <FooterCompinent />
  </div>
</template>

<script>
  import ComponentHeader from "@/components/Header.vue";
  import FooterCompinent from "@/components/Footer.vue";
  import ServicesComponet from "@/components/servicesComponent.vue";
  import SliderComponent from "@/components/SliderComponent.vue"
  export default {
    name: 'HomeView',
    components: {
      ComponentHeader,
      FooterCompinent,
      ServicesComponet,
      SliderComponent
    },
    data: () => ({
      model: 0,
      servicesData: [{
          title: "Web Development",
          img: `<svg xmlns="http://www.w3.org/2000/svg" width="52.575" height="45" viewBox="465.67 2075.427 52.575 45">
                <g data-name="Group 1019">
                    <g data-name="Group 1008">
                        <path
                            d="m506.014 2098.32-7.338-4.645a1.236 1.236 0 0 0-1.664.316 1.274 1.274 0 0 0-.047.068 1.24 1.24 0 0 0 .334 1.675 1.257 1.257 0 0 0 .051.035l5.767 3.65-5.692 3.985a1.232 1.232 0 0 0-.485.69c-.087.322-.045.677.143.978a1.258 1.258 0 0 0 .037.057 1.227 1.227 0 0 0 .726.495 1.253 1.253 0 0 0 .29.034 1.245 1.245 0 0 0 .053-.001 1.23 1.23 0 0 0 .614-.194 1.243 1.243 0 0 0 .043-.029l7.216-5.052a1.236 1.236 0 0 0 .53-1.015 1.251 1.251 0 0 0 0-.029 1.24 1.24 0 0 0-.578-1.017Z"
                            fill="#fff" fill-rule="evenodd" data-name="Path 3186" />
                    </g>
                    <g data-name="Group 1009">
                        <path
                            d="m485.237 2093.674-7.339 4.647a1.248 1.248 0 0 0-.576 1.017 1.266 1.266 0 0 0 0 .023 1.244 1.244 0 0 0 .53 1.021l7.217 5.051a1.248 1.248 0 0 0 .486.204c.074.013.149.02.223.02a1.238 1.238 0 0 0 .983-.481 1.257 1.257 0 0 0 .035-.048 1.235 1.235 0 0 0 .21-.537 1.239 1.239 0 0 0-.517-1.188l-5.691-3.983 5.764-3.652a1.24 1.24 0 0 0-1.273-2.125 1.266 1.266 0 0 0-.052.031Z"
                            fill="#fff" fill-rule="evenodd" data-name="Path 3187" />
                    </g>
                    <g data-name="Group 1010">
                        <path
                            d="M514.522 2075.427h-45.13a3.737 3.737 0 0 0-3.722 3.743v5.86a1.235 1.235 0 0 0 1.232 1.239h50.11a1.235 1.235 0 0 0 1.233-1.24v-5.86c0-2.062-1.67-3.742-3.723-3.742Zm1.258 8.364h-47.646v-4.621a1.262 1.262 0 0 1 1.258-1.265h45.13c.693 0 1.258.568 1.258 1.265v4.62Z"
                            fill="#fff" fill-rule="evenodd" data-name="Path 3188" />
                    </g>
                    <g data-name="Group 1011">
                        <path
                            d="M515.78 2090.286v26.428a1.259 1.259 0 0 1-1.258 1.255h-45.13a1.257 1.257 0 0 1-1.258-1.255v-26.428a1.23 1.23 0 0 0-1.232-1.23 1.23 1.23 0 0 0-1.232 1.23v26.428a3.723 3.723 0 0 0 3.723 3.713h45.129a3.723 3.723 0 0 0 3.723-3.713v-26.428a1.23 1.23 0 0 0-1.232-1.23 1.23 1.23 0 0 0-1.233 1.23Z"
                            fill="#fff" fill-rule="evenodd" data-name="Path 3189" />
                    </g>
                    <g data-name="Group 1012">
                        <path
                            d="m491.02 2107.527 4.26-15.178a1.24 1.24 0 0 0-.859-1.528 1.252 1.252 0 0 0-.108-.025 1.235 1.235 0 0 0-.225-.021 1.242 1.242 0 0 0-1.194.903l-4.26 15.179c-.186.66.2 1.343.857 1.528a1.278 1.278 0 0 0 .013.003c.089.024.178.037.264.042a1.236 1.236 0 0 0 .06.001 1.24 1.24 0 0 0 1.193-.904Z"
                            fill="#fff" fill-rule="evenodd" data-name="Path 3190" />
                    </g>
                    <g data-name="Group 1013">
                        <path
                            d="M471.601 2079.396a1.297 1.297 0 0 0-1.294 1.297 1.296 1.296 0 0 0 1.294 1.295 1.297 1.297 0 0 0 1.298-1.295c0-.716-.581-1.297-1.298-1.297Z"
                            fill="#fff" fill-rule="evenodd" data-name="Path 3191" />
                    </g>
                    <g data-name="Group 1014">
                        <path
                            d="M476.348 2079.396c-.714 0-1.295.58-1.295 1.297a1.296 1.296 0 0 0 1.295 1.295c.716 0 1.297-.581 1.297-1.295a1.297 1.297 0 0 0-1.297-1.297Z"
                            fill="#fff" fill-rule="evenodd" data-name="Path 3192" />
                    </g>
                    <g data-name="Group 1015">
                        <path
                            d="M481.122 2079.396a1.297 1.297 0 0 0-1.296 1.297 1.297 1.297 0 0 0 2.592 0 1.297 1.297 0 0 0-1.296-1.297Z"
                            fill="#fff" fill-rule="evenodd" data-name="Path 3193" />
                    </g>
                    <g data-name="Group 1016">
                        <path
                            d="M472.899 2114.206h4.026a1.238 1.238 0 1 0 0-2.478H472.9c-.685 0-1.24.554-1.24 1.24a1.238 1.238 0 0 0 1.24 1.238Z"
                            fill="#fff" fill-rule="evenodd" data-name="Path 3194" />
                    </g>
                    <g data-name="Group 1017">
                        <path
                            d="M511.326 2111.728h-10.532a1.238 1.238 0 0 0-1.24 1.24 1.238 1.238 0 0 0 1.24 1.238h10.532a1.238 1.238 0 0 0 1.239-1.239c0-.685-.554-1.239-1.24-1.239Z"
                            fill="#fff" fill-rule="evenodd" data-name="Path 3195" />
                    </g>
                    <g data-name="Group 1018">
                        <path
                            d="M511.326 2106.838h-4.646a1.238 1.238 0 1 0 0 2.478h4.646c.685 0 1.24-.554 1.24-1.24a1.238 1.238 0 0 0-1.24-1.238Z"
                            fill="#fff" fill-rule="evenodd" data-name="Path 3196" />
                    </g>
                </g>
            </svg>`
        },
        {
          title: "Business Automation",
          img: `<svg xmlns="http://www.w3.org/2000/svg" width="53.215" height="50"
                    viewBox="934.242 2073.543 53.215 50">
                    <g data-name="Group 1020">
                      <path
                        d="M962.13 2105.287v-6.014a1.282 1.282 0 0 0-1.282-1.283 1.282 1.282 0 0 0-1.283 1.283v6.017a6.268 6.268 0 0 0-4.972 6.124 1.283 1.283 0 1 0 2.566 0 3.697 3.697 0 0 1 3.692-3.695 3.696 3.696 0 0 1 3.691 3.695 1.283 1.283 0 0 0 1.283 1.282c.708 0 1.283-.574 1.283-1.282a6.269 6.269 0 0 0-4.977-6.127Z"
                        fill="#fff" fill-rule="evenodd" data-name="Path 3197" />
                      <path
                        d="m983.194 2120.873-43.878.002a2.374 2.374 0 0 1-1.634-.705c-.37-.358-.63-.799-.728-1.197a1.42 1.42 0 0 1-.045-.341v-1.147h2.668a1.333 1.333 0 0 0 1.333-1.334v-21.86a4.802 4.802 0 0 1 .549-2.338c.855-1.558 2.683-2.415 5.294-2.415h7.692v2.796a.244.244 0 0 1-.026.093c-.082.184-.347.498-.586.781a23.483 23.483 0 0 0-.49.595c-1.003 1.27-2.177 3.214-2.233 7.082a20.055 20.055 0 0 0-.002.292c0 .645.46 1.196 1.096 1.311.223.041.483.068.773.075a6.246 6.246 0 0 0 .149.002 6.822 6.822 0 0 0 1.093-.09 6.877 6.877 0 0 0 4.496-2.763 7.997 7.997 0 0 0 .57-.9 1.335 1.335 0 0 0-.496-1.789 1.36 1.36 0 0 0-.036-.02 1.335 1.335 0 0 0-1.81.532 5.387 5.387 0 0 1-.46.71c-.842 1.094-1.874 1.48-2.654 1.603.233-2.716 1.182-3.898 1.985-4.851a133.256 133.256 0 0 1 .058-.07 121.071 121.071 0 0 0 .058-.068c.443-.527.886-1.071 1.08-1.77a2.801 2.801 0 0 0 .102-.755v-9.344c0-2.782 2.19-5.109 3.512-6.261a14.462 14.462 0 0 1 .23-.197 14.05 14.05 0 0 1 .472.41c.77.699 1.764 1.754 2.45 3.043a6.396 6.396 0 0 1 .812 3.005v9.342c0 1.124.63 1.873 1.24 2.595a19.872 19.872 0 0 1 .411.499c.59.746 1.191 1.704 1.49 3.348a11.435 11.435 0 0 1 .14 1.065 4.246 4.246 0 0 1-.62-.15c-.69-.221-1.469-.671-2.117-1.56a5.37 5.37 0 0 1-.376-.595 1.33 1.33 0 0 0-.754-.628 1.338 1.338 0 0 0-1.008.072 1.383 1.383 0 0 0-.047.024 1.334 1.334 0 0 0-.532 1.81 7.773 7.773 0 0 0 .905 1.324c1.83 2.148 4.338 2.543 5.801 2.402a4.507 4.507 0 0 0 .376-.052 1.333 1.333 0 0 0 1.094-1.311 17.518 17.518 0 0 0-.102-1.936c-.325-2.927-1.37-4.497-2.245-5.576a29.253 29.253 0 0 0-.377-.455 63.052 63.052 0 0 1-.092-.109c-.26-.31-.52-.633-.52-.767v-2.794h8.776a8.817 8.817 0 0 1 1.74.152c2.144.435 3.016 1.835 3.016 4.602v21.859c0 .737.597 1.334 1.333 1.334h2.67v1.147a2.706 2.706 0 0 1-.002.1c-.017.445-.164 1.98-1.396 2.13a1.651 1.651 0 0 1-.198.011Zm2.929-6.055h-2.67v-20.526a10.839 10.839 0 0 0-.25-2.417c-.779-3.407-3.26-4.617-5.74-4.92a11.828 11.828 0 0 0-1.432-.084h-8.776v-3.881c0-5.134-4.923-8.726-5.603-9.2a6.246 6.246 0 0 0-.065-.045 1.276 1.276 0 0 0-.71-.202c-.296 0-.598.089-.841.253-.21.142-4.795 3.288-5.5 7.986a8.129 8.129 0 0 0-.091 1.208v3.88h-7.692a11.047 11.047 0 0 0-3.704.593c-2.793.993-4.546 3.18-4.78 6.143a8.75 8.75 0 0 0-.026.686v20.526h-2.668c-.736 0-1.333.597-1.333 1.333v2.48a3.967 3.967 0 0 0 .059.675c.365 2.118 2.39 4.237 5.015 4.237l43.878-.003c2.735 0 4.078-2.218 4.245-4.436a6.318 6.318 0 0 0 .018-.472v-2.481a1.333 1.333 0 0 0-1.334-1.333Z"
                        fill="#fff" fill-rule="evenodd" data-name="Path 3198" />
                      <path
                        d="M976.668 2115.156h-10.236a1.405 1.405 0 0 0-.954.367 1.245 1.245 0 0 0-.41.888h-8.44a1.31 1.31 0 0 0-1.124-1.235 1.456 1.456 0 0 0-.238-.02h-10.234a1.402 1.402 0 0 0-.96.373 1.243 1.243 0 0 0-.402.91 1.308 1.308 0 0 0 1.13 1.264 1.456 1.456 0 0 0 .232.019h8.87a1.31 1.31 0 0 0 1.125 1.236 1.457 1.457 0 0 0 .239.02h11.166a1.403 1.403 0 0 0 .954-.368 1.246 1.246 0 0 0 .409-.888h8.873a1.402 1.402 0 0 0 .96-.373 1.243 1.243 0 0 0 .403-.91 1.308 1.308 0 0 0-1.13-1.264 1.456 1.456 0 0 0-.233-.019Z"
                        fill="#fff" fill-rule="evenodd" data-name="Path 3199" />
                      <path
                        d="M949.616 2112.811a1.282 1.282 0 0 0 1.283-1.283 3.044 3.044 0 0 1 1.898-2.825 1.28 1.28 0 0 0 .746-.828c.049-.166.064-.343.042-.52a1.285 1.285 0 0 0-.086-.325 1.282 1.282 0 0 0-.848-.75 1.286 1.286 0 0 0-.485-.038 1.282 1.282 0 0 0-.34.086 5.6 5.6 0 0 0-3.492 5.2 1.282 1.282 0 0 0 1.282 1.283Z"
                        fill="#fff" fill-rule="evenodd" data-name="Path 3200" />
                      <path
                        d="M970.8 2111.528a3.049 3.049 0 0 0-1.9-2.828 1.283 1.283 0 0 1-.784-1.35 1.286 1.286 0 0 1 .087-.324c.221-.544.775-.85 1.33-.788a1.278 1.278 0 0 1 .343.09 5.606 5.606 0 0 1 3.49 5.2c0 .71-.574 1.283-1.283 1.283a1.282 1.282 0 0 1-1.283-1.283Z"
                        fill="#fff" fill-rule="evenodd" data-name="Path 3201" />
                    </g>
                  </svg>`
        },
        {
          title: "Mobile Development",
          img: `<svg xmlns="http://www.w3.org/2000/svg" width="41.839" height="50" viewBox="1408 2074 41.839 50">
                    <g data-name="Group 1021">
                      <path
                        d="M1434.57 2114.782v.002h-24.031v-31.569h24.032v.508a1.285 1.285 0 0 0 1.269 1.3 1.285 1.285 0 0 0 1.27-1.3v-2.018c0-4.248-3.375-7.705-7.523-7.705h-14.066a7.624 7.624 0 0 0-7.52 7.705v34.59a7.624 7.624 0 0 0 7.52 7.705h14.066a7.624 7.624 0 0 0 7.522-7.706v-1.512c0-.718-.568-1.3-1.269-1.3s-1.27.582-1.27 1.3Zm-4.983 6.617h-14.066c-2.382 0-4.372-1.723-4.861-4.014h23.79c-.49 2.291-2.481 4.014-4.863 4.014Zm-14.066-44.798h14.066c2.382 0 4.373 1.722 4.863 4.013h-23.79c.489-2.29 2.48-4.013 4.861-4.013Z"
                        fill="#fff" fill-rule="evenodd" data-name="Path 3202" />
                      <path
                        d="M1448.462 2086.722h-33.278c-.76 0-1.378.55-1.378 1.23v22.395a1.235 1.235 0 0 0 .826 1.128 1.516 1.516 0 0 0 .552.103h33.278c.76 0 1.377-.551 1.377-1.23v-22.396a1.235 1.235 0 0 0-.826-1.128 1.516 1.516 0 0 0-.551-.102Zm-31.9 22.395v-16.415h30.522v16.415h-30.522Zm30.522-19.934v1.058h-30.522v-1.058h30.522Z"
                        fill="#fff" fill-rule="evenodd" data-name="Path 3203" />
                      <path
                        d="M1420.559 2104.765h14.092a1.378 1.378 0 0 0 1.378-1.378v-8.497a1.378 1.378 0 0 0-1.378-1.378h-14.092a1.378 1.378 0 0 0-1.378 1.378v8.497c0 .761.616 1.378 1.378 1.378Zm1.377-8.498h11.337v5.742h-11.337v-5.742Z"
                        fill="#fff" fill-rule="evenodd" data-name="Path 3204" />
                      <path
                        d="M1443.637 2093.96h-6.218a1.378 1.378 0 0 0-1.378 1.378c0 .762.617 1.379 1.378 1.379h6.218c.761 0 1.378-.617 1.378-1.379a1.377 1.377 0 0 0-1.378-1.377Z"
                        fill="#fff" fill-rule="evenodd" data-name="Path 3205" />
                      <path
                        d="M1437.901 2100.617h3.731a1.377 1.377 0 0 0 1.378-1.378 1.378 1.378 0 0 0-1.378-1.378h-3.731c-.761 0-1.378.617-1.378 1.378a1.378 1.378 0 0 0 1.378 1.378Z"
                        fill="#fff" fill-rule="evenodd" data-name="Path 3206" />
                      <path
                        d="M1437.42 2104.515h5.595a1.378 1.378 0 0 0 1.378-1.378c0-.761-.616-1.378-1.378-1.378h-5.596c-.76 0-1.378.617-1.378 1.378a1.378 1.378 0 0 0 1.378 1.378Z"
                        fill="#fff" fill-rule="evenodd" data-name="Path 3207" />
                      <path
                        d="M1443.637 2105.464h-24.25c-.76 0-1.378.616-1.378 1.378a1.377 1.377 0 0 0 1.378 1.378h24.25a1.377 1.377 0 0 0 1.378-1.378c0-.762-.617-1.378-1.378-1.378Z"
                        fill="#fff" fill-rule="evenodd" data-name="Path 3208" />
                      <path
                        d="M1424.254 2117.65h-2.27a1.378 1.378 0 0 0-1.378 1.377 1.378 1.378 0 0 0 1.378 1.378h2.27a1.378 1.378 0 0 0 1.378-1.378c0-.761-.616-1.378-1.378-1.378Z"
                        fill="#fff" fill-rule="evenodd" data-name="Path 3209" />
                    </g>
                  </svg>`
        },
        {
          title: "UI/UX Design",
          img: ` <svg xmlns="http://www.w3.org/2000/svg" width="42.446" height="50" viewBox="470.999 2502 42.446 50">
                    <g data-name="Group 1028">
                      <g data-name="Group 1022">
                        <path
                          d="m477.196 2521.83 4.807-4.859a1.024 1.024 0 0 0 .296-.721 1.043 1.043 0 0 0 0-.008 1.019 1.019 0 0 0-.31-.723l-3.27-3.19a4.42 4.42 0 0 0-3.092-1.252c-1.216 0-2.35.481-3.197 1.355a4.421 4.421 0 0 0-1.181 2.324 4.45 4.45 0 0 0 1.283 3.962l3.225 3.127a1.016 1.016 0 0 0 .513.27 1.026 1.026 0 0 0 .926-.284Zm.098-8.033 2.528 2.468-3.367 3.405-2.498-2.422a2.387 2.387 0 0 1-.687-1.278 2.402 2.402 0 0 1 .532-2.004 2.425 2.425 0 0 1 .1-.11 2.38 2.38 0 0 1 1.725-.731 2.394 2.394 0 0 1 1.667.672Z"
                          fill="#fff" fill-rule="evenodd" data-name="Path 3210" />
                      </g>
                      <g data-name="Group 1023">
                        <path
                          d="m492.097 2525.625-7.357-7.084a1.006 1.006 0 0 0-1.366-.024 1.012 1.012 0 0 0-.05.047l-4.65 4.78a.989.989 0 0 0-.282.693 1.012 1.012 0 0 0 0 .015.985.985 0 0 0 .305.698l7.734 7.433a60.36 60.36 0 0 0-.884 1.183 1 1 0 0 0-.404-.089.89.89 0 0 0-.039 0 .995.995 0 0 0-.738.374l-5.14 6.396c-.021.029-.03.064-.05.095-1.133.192-2.422.592-3.519 1.404a6.062 6.062 0 0 0-.538.449c-2.581 2.417-4.03 8.263-4.091 8.51a.985.985 0 0 0-.025.155.984.984 0 0 0-.004.08.99.99 0 0 0 .273.682 1.006 1.006 0 0 0 .905.297 12.017 12.017 0 0 0 .16-.03c.879-.169 4.98-1.025 7.592-2.72a7.435 7.435 0 0 0 1.036-.798 6.528 6.528 0 0 0 1.392-1.936 9.573 9.573 0 0 0 .687-1.967l.043-.019a.367.367 0 0 0 .08-.041l6.727-4.716a.994.994 0 0 0 .42-.713c.001-.023-.004-.044-.008-.066a.23.23 0 0 1-.005-.044c.318-.211.725-.486 1.204-.82a66.295 66.295 0 0 0 .46-.324l11.162 10.748a.943.943 0 0 0 .493.241 1.408 1.408 0 0 0 .036.007l8.169 3.402a1.008 1.008 0 0 0 .306.074 1.004 1.004 0 0 0 .08.003.997.997 0 0 0 .999-1.042.99.99 0 0 0-.089-.367l-3.686-8.01a.993.993 0 0 0-.245-.498.837.837 0 0 0-.02-.02l-10.403-10.014a59.729 59.729 0 0 0 1.54-1.442 36.235 36.235 0 0 0 1.016-1.028c5.807-6.1 11.727-16.089 11.99-16.535a.977.977 0 0 0-.2-1.221.988.988 0 0 0-1.27-.293 52.88 52.88 0 0 0-.345.19c-2.008 1.113-11.922 6.727-17.568 12.09a66.146 66.146 0 0 0-1.833 1.815Zm15.476 17.691.965 2.098-2.067 2.123-2.139-.891a.032.032 0 0 0-.011-.003c-.006 0-.01 0-.014-.002l-10.709-10.312a75.402 75.402 0 0 0 .798-.61 74.843 74.843 0 0 0 .276-.214l9.707 9.344a.996.996 0 0 0 .555.27 1.013 1.013 0 0 0 .14.01.998.998 0 0 0 .672-.258 1.013 1.013 0 0 0 .048-.045.99.99 0 0 0-.024-1.407l-9.53-9.175a83.832 83.832 0 0 0 1.03-.868l10.297 9.915a.036.036 0 0 1 .003.012l.002.01a.027.027 0 0 0 .001.003Zm-18.429-6.273-2.149-2.27c1.087-1.504 4.16-5.577 8.317-9.524 3.522-3.346 8.92-6.882 12.79-9.236a145.297 145.297 0 0 1 1.622-.973 145.214 145.214 0 0 1-1.018 1.57c-2.4 3.651-5.958 8.701-9.33 12.112a31.664 31.664 0 0 1-.465.46c-4.065 3.945-8.186 6.811-9.767 7.86Zm-8.337-13.03 3.26-3.35 6.66 6.411c-.31.337-.608.667-.895.992l-2.962-2.841a.99.99 0 0 0-.523-.265 1.005 1.005 0 0 0-.889.29.99.99 0 0 0 .024 1.407l3.043 2.92a80.03 80.03 0 0 0-.439.527 71.716 71.716 0 0 0-.413.506l-6.866-6.598Zm-.873 18.026 1.275 1.348c-.203 1.094-.648 2.429-1.615 3.335a6.064 6.064 0 0 1-1.065.773c-1.474.868-3.552 1.521-5.106 1.913a30.433 30.433 0 0 1 .348-1.021c.647-1.795 1.6-3.895 2.72-4.944.861-.806 2.037-1.182 3.065-1.35a9.4 9.4 0 0 1 .378-.054Zm2.79.045-1.392-1.47 3.876-4.826 2.592 2.738-5.077 3.558Zm25.728 6.277.979-1.004.805 1.748-1.784-.744Z"
                          fill="#fff" fill-rule="evenodd" data-name="Path 3211" />
                      </g>
                      <g data-name="Group 1024">
                        <path
                          d="M486.903 2513.645a1.024 1.024 0 0 0 .947-.639 4.756 4.756 0 0 1 1.209-1.727 3.01 3.01 0 0 1-.014.105c-.01.07-.019.14-.019.213a3.204 3.204 0 0 0 3.199 3.199 3.202 3.202 0 0 0 3.199-3.2c0-.107-.02-.21-.032-.316.515.467.933 1.05 1.21 1.726a1.02 1.02 0 0 0 .571.567 1.019 1.019 0 0 0 .374.07 1.05 1.05 0 0 0 .055 0 .994.994 0 0 0 .33-.075 1.02 1.02 0 0 0 .586-.623 1.015 1.015 0 0 0-.023-.71 6.745 6.745 0 0 0-6.27-4.221 6.744 6.744 0 0 0-6.27 4.22 1.027 1.027 0 0 0-.067.255 1.022 1.022 0 0 0 1.015 1.156Zm4.17-2.048a1.154 1.154 0 0 0 1.152 1.151 1.152 1.152 0 0 0 1.151-1.151 1.153 1.153 0 0 0-1.151-1.152 1.154 1.154 0 0 0-1.152 1.152Z"
                          fill="#fff" fill-rule="evenodd" data-name="Path 3212" />
                      </g>
                      <g data-name="Group 1025">
                        <path
                          d="M493.249 2504.431v-1.407c0-.566-.458-1.024-1.024-1.024a1.023 1.023 0 0 0-1.024 1.024v1.407c0 .566.458 1.024 1.024 1.024a1.023 1.023 0 0 0 1.024-1.024Z"
                          fill="#fff" fill-rule="evenodd" data-name="Path 3213" />
                      </g>
                      <g data-name="Group 1026">
                        <path
                          d="m487.02 2505.933-.996-.996a1.02 1.02 0 0 0-.515-.278 1.02 1.02 0 0 0-.88.229 1.036 1.036 0 0 0-.052.049c-.382.381-.4.987-.054 1.39a1.04 1.04 0 0 0 .054.057l.997.996c.198.2.46.3.722.3a1.019 1.019 0 0 0 .69-.268 1.047 1.047 0 0 0 .034-.032 1.02 1.02 0 0 0 .28-.528 1.024 1.024 0 0 0-.28-.92Z"
                          fill="#fff" fill-rule="evenodd" data-name="Path 3214" />
                      </g>
                      <g data-name="Group 1027">
                        <path
                          d="m498.878 2507.38.996-.996c.4-.4.4-1.047 0-1.447a1.019 1.019 0 0 0-.517-.279 1.023 1.023 0 0 0-.93.279l-.997.996a1.02 1.02 0 0 0-.278.516c-.068.326.025.678.278.931a1.019 1.019 0 0 0 .516.279c.068.014.137.02.207.021a.743.743 0 0 0 .001 0 1.02 1.02 0 0 0 .666-.246 1.038 1.038 0 0 0 .058-.054Z"
                          fill="#fff" fill-rule="evenodd" data-name="Path 3215" />
                      </g>
                    </g>
                  </svg>`
        },
        {
          title: "Telegram Bots",
          img: `<svg xmlns="http://www.w3.org/2000/svg" width="45.212" height="60.21"
                    viewBox="2182.901 3012.57 45.212 60.21">
                    <path
                      d="m2213.79 3046.828-3.63 6.913-.994-4.922c2.05-.769 3.46-1.986 3.828-2.328a3.159 3.159 0 0 0 .092-.088 1.5 1.5 0 0 0 .437-1.037l.07-4.981a9.88 9.88 0 0 0 .28-.323c.325-.39.708-.909 1.062-1.54a9.695 9.695 0 0 0 .333-.648 3.65 3.65 0 0 0 1.549-1.564c.437-.804.699-1.837.759-3.059a325.272 325.272 0 0 0 .002-.042c.048-.96.095-2.087-.453-3.085a3.305 3.305 0 0 0-.206-.327c.156-2.043-.04-3.956-.566-5.653a10.771 10.771 0 0 0-2.143-3.922 9.869 9.869 0 0 0-5.443-3.141 13.26 13.26 0 0 0-2.53-.296l-1.207.002a.061.061 0 0 0-.017.002c-.008.003-.016.006-.025.006a13.06 13.06 0 0 1-.743-.032c-1.873-.132-5.368-.763-7.28-3.544a1.53 1.53 0 0 0-1.265-.649c-.037 0-.073.002-.11.004a1.592 1.592 0 0 0-.032.003 1.502 1.502 0 0 0-1.227.94 6.568 6.568 0 0 0-.053.143c-.375 1.019-2.36 6.935.24 10.99a7.1 7.1 0 0 0 .19.28 14.825 14.825 0 0 0-.402 3.025c-.006.173-.008.346-.008.52a17.222 17.222 0 0 0 .05 1.319 3.39 3.39 0 0 0-.474.953c-.263.825-.225 1.693-.187 2.455a372.893 372.893 0 0 0 .002.048c.068 1.373.389 2.508.927 3.347a3.529 3.529 0 0 0 1.383 1.28 10.289 10.289 0 0 0 1.671 2.508l.07 4.981c.007.414.183.807.489 1.087a4.146 4.146 0 0 0 .1.086 13.81 13.81 0 0 0 3.653 2.159 12.467 12.467 0 0 0 .131.05l-1.074 5.317-3.801-7.237a1.5 1.5 0 0 0-1.331-.802c-.082 0-.164.006-.246.02a1.535 1.535 0 0 0-.115.023 30.345 30.345 0 0 0-.28.072c-1.527.398-7.492 2.055-10.126 4.318a5.532 5.532 0 0 0-.552.54 3.795 3.795 0 0 0-.576.95c-1.263 2.824-1.525 9.062-.39 11.107a2.005 2.005 0 0 0 .182.276 16.664 16.664 0 0 0 4.725 4.443c4.832 3.162 11.51 4.964 16.89 5a.041.041 0 0 1 .011.003.03.03 0 0 0 .012.002l.036-.001a.802.802 0 0 1 .036-.001.799.799 0 0 1 .036 0l.036.002a.033.033 0 0 0 .01-.002c.004 0 .009-.003.014-.003a29.36 29.36 0 0 0 4.11-.333c6.747-1.007 14.202-4.242 17.437-9.02a2.972 2.972 0 0 0 .437-.84c1.029-2.866.47-9.736-1.154-11.583a6.588 6.588 0 0 0-1.102-.97c-2.972-2.14-8.666-3.657-9.754-3.934a25.519 25.519 0 0 0-.102-.026 1.55 1.55 0 0 0-.085-.018 1.527 1.527 0 0 0-.276-.025 1.502 1.502 0 0 0-1.331.802Zm9.118 16.85v-5.45a1.5 1.5 0 0 0-1.5-1.5 1.501 1.501 0 0 0-1.502 1.5v7.608a28.447 28.447 0 0 1-5.76 2.527 30.987 30.987 0 0 1-5.083 1.155 26.532 26.532 0 0 1-3.549.258c-4.382-.013-9.1-1.237-12.9-3.14a25.032 25.032 0 0 1-1.492-.809v-7.599a1.5 1.5 0 0 0-1.501-1.5 1.5 1.5 0 0 0-1.501 1.5v5.44c-.744-.664-1.386-1.358-1.874-2.078-.656-1.122-.346-6.508.376-8.223a1.504 1.504 0 0 1 .22-.387 3.176 3.176 0 0 1 .36-.343c1.383-1.145 4.587-2.351 7.207-3.14a46.534 46.534 0 0 1 .729-.212l9.059 17.246c.006.011.017.018.023.029a1.446 1.446 0 0 0 .303.373c.04.036.08.069.124.1a.65.65 0 0 1 .062.053c.028.027.057.054.093.074a.256.256 0 0 0 .003.002.355.355 0 0 0 .096.03l.024.006a.432.432 0 0 1 .058.016 1.181 1.181 0 0 0 .048.018 1.558 1.558 0 0 0 .176.048 1.855 1.855 0 0 0 .152.025 1.432 1.432 0 0 0 .45-.022 1.481 1.481 0 0 0 .226-.064 1.136 1.136 0 0 0 .02-.008.46.46 0 0 1 .073-.02.367.367 0 0 0 .092-.027.201.201 0 0 0 .003-.002c.036-.019.064-.046.092-.072a.569.569 0 0 1 .06-.052c.048-.034.09-.069.133-.108a1.45 1.45 0 0 0 .3-.37.058.058 0 0 1 .01-.014c.005-.004.01-.01.013-.015l3.858-7.344c.128-.157.223-.334.28-.532l4.921-9.37c2.973.84 7.11 2.345 8.295 3.695a1.645 1.645 0 0 1 .249.458c.655 1.667.95 6.363.43 7.924a1.489 1.489 0 0 1-.125.284c-.477.703-1.104 1.382-1.83 2.033Zm-17.281-43.89h.576a9.715 9.715 0 0 1 2.452.352 6.73 6.73 0 0 1 3.293 2.055 7.858 7.858 0 0 1 1.584 2.984c.408 1.39.535 2.993.364 4.728a16.171 16.171 0 0 1-.025.232 1.504 1.504 0 0 0-.01.167 1.504 1.504 0 0 0 .524 1.14.482.482 0 0 1 .14.213c.076.215.091.576.063 1.245a26.796 26.796 0 0 1-.01.198 6.622 6.622 0 0 1-.065.665c-.125.82-.385 1.324-.627 1.437a.265.265 0 0 1-.058.02 1.503 1.503 0 0 0-1.12 1.009 6.37 6.37 0 0 1-.29.635 7.305 7.305 0 0 1-1.234 1.695 3.449 3.449 0 0 1-.051.05c-2.13 1.685-3.726 1.621-5.127 1.557a4672.013 4672.013 0 0 0-.045-.002 24.41 24.41 0 0 0-.403-.019 9.96 9.96 0 0 0-.373-.008 1.501 1.501 0 0 0-1.501 1.501c0 .83.672 1.502 1.501 1.502a7.913 7.913 0 0 1 .302.006 36.716 36.716 0 0 1 .327.015c.295.016.63.032.998.032a12.84 12.84 0 0 0 .018 0 9.35 9.35 0 0 0 2.542-.334 9.222 9.222 0 0 0 1.19-.422l-.031 2.212c-.786.621-2.582 1.817-4.77 1.817-2.052 0-3.867-1.039-4.814-1.7a10.492 10.492 0 0 1-.216-.154l-.067-4.875a1.524 1.524 0 0 0-.494-1.091 1.721 1.721 0 0 1-.038-.037 7.342 7.342 0 0 1-1.576-2.386 1.694 1.694 0 0 0-.028-.075 1.867 1.867 0 0 0-.075-.163 1.432 1.432 0 0 0-.013-.025 1.501 1.501 0 0 0-1.008-.742.289.289 0 0 1-.097-.04c-.25-.16-.512-.738-.614-1.648a7.036 7.036 0 0 1-.035-.434 26.462 26.462 0 0 1-.01-.21c-.028-.678-.01-1.036.07-1.246a.469.469 0 0 1 .133-.195 1.502 1.502 0 0 0 .527-1.143 1.511 1.511 0 0 0-.009-.167 15.255 15.255 0 0 1-.097-1.489c-.012-.831.05-1.627.184-2.38a10.626 10.626 0 0 1 .174-.796c.072-.277.037-.547-.04-.803a1.648 1.648 0 0 0 .029-.291 1.448 1.448 0 0 0-.273-.874 1.44 1.44 0 0 0-.055-.072c-1.298-1.562-1.274-4.066-.923-6.095a15.966 15.966 0 0 1 .056-.309 10.938 10.938 0 0 0 1.701 1.12c3.282 1.754 6.87 1.668 7.474 1.638Zm.6 29.645 1.72 8.52-2.433 4.631-2.262-4.306 1.79-8.865a7.816 7.816 0 0 1 .246.025h.008a4.164 4.164 0 0 0 .465.034 2.231 2.231 0 0 0 .262-.02c.068-.007.135-.015.205-.02Zm-.797 23.345h.004"
                      fill="#fff" fill-rule="evenodd" data-name="Path 3216" /></svg>`
        },
        {
          title: "SMM",
          img: ` <svg xmlns="http://www.w3.org/2000/svg" width="59.713" height="50" viewBox="1399 2502 59.713 50">
                    <g data-name="Group 1034">
                      <g data-name="Group 1030">
                        <path
                          d="M1439.828 2513.865v-10.356c0-.583-.333-1.114-.856-1.364a1.474 1.474 0 0 0-.637-.145 1.494 1.494 0 0 0-.951.342c-.105.089-10.85 8.807-27.085 8.93a.18.18 0 0 1-.002.002.118.118 0 0 1-.022.005.024.024 0 0 1-.002 0h-3.425a7.894 7.894 0 0 0-7.848 7.92v4.985c0 4.363 3.521 7.914 7.848 7.914h2.254l2.537 15.786c.036.158.908 3.67 6.26 4.078a13.728 13.728 0 0 0 1.042.038 10.677 10.677 0 0 0 1.742-.132c1.463-.243 2.535-.82 3.195-1.724.879-1.202.674-2.498.575-2.92l-2.388-13.518c8.97 2.467 14.812 6.91 15.301 7.293a2.098 2.098 0 0 1 .033.026 1.484 1.484 0 0 0 .934.33 1.518 1.518 0 0 0 .648-.147 1.515 1.515 0 0 0 .847-1.362v-9.443a8.384 8.384 0 0 0 6.887-8.267 8.383 8.383 0 0 0-6.887-8.27Zm-37.838 10.319v-4.986a4.884 4.884 0 0 1 4.858-4.902h4.198c.033 0 .063-.01.093-.018a.391.391 0 0 1 .074-.018 49.977 49.977 0 0 0 7.244-.714 49.907 49.907 0 0 0 6.201-1.486 49.863 49.863 0 0 0 1.296-.419v20.077a49.394 49.394 0 0 0-6.15-1.679c-2.501-.51-5.194-.855-8.051-.944v-9.36a1.5 1.5 0 0 0-1.495-1.509 1.501 1.501 0 0 0-1.495 1.509v9.346h-1.915c-2.68 0-4.858-2.199-4.858-4.897Zm26.954 8.662v-22.319a50.988 50.988 0 0 0 1.662-.716 48.714 48.714 0 0 0 4.809-2.5 42.064 42.064 0 0 0 1.423-.885v30.527a43.47 43.47 0 0 0-1.413-.875 50.542 50.542 0 0 0-5.717-2.909 51.953 51.953 0 0 0-.764-.323Zm-14.391 14.346-2.415-15.053a45.165 45.165 0 0 1 5.141.514 41.317 41.317 0 0 1 1.615.29l2.654 14.997a.56.56 0 0 1-.053.382.416.416 0 0 1-.031.045c-.206.256-.812.526-1.929.598a9.316 9.316 0 0 1-.594.018 10.693 10.693 0 0 1-.925-.038c-2.53-.22-3.259-1.323-3.432-1.683a1.148 1.148 0 0 1-.031-.07Zm25.275-19.894v-10.327a5.367 5.367 0 0 1 3.897 5.165 5.366 5.366 0 0 1-3.897 5.162Z"
                          fill="#fff" fill-rule="evenodd" data-name="Path 3219" />
                      </g>
                      <g data-name="Group 1031">
                        <path
                          d="M1457.148 2519.506h-3.544a1.563 1.563 0 0 0-1.565 1.566c0 .865.697 1.566 1.565 1.566h3.544a1.564 1.564 0 0 0 1.566-1.566c0-.865-.7-1.566-1.566-1.566Z"
                          fill="#fff" fill-rule="evenodd" data-name="Path 3220" />
                      </g>
                      <g data-name="Group 1032">
                        <path
                          d="m1452.002 2511.073 2.333-2.095a1.556 1.556 0 0 0 .477-.795c.117-.484 0-1.016-.358-1.415a1.557 1.557 0 0 0-.826-.484 1.559 1.559 0 0 0-1.384.364l-2.333 2.095a1.557 1.557 0 0 0-.48.807c-.104.448-.01.935.29 1.32a1.585 1.585 0 0 0 .07.084c.31.345.737.52 1.166.52.372 0 .749-.132 1.045-.4Z"
                          fill="#fff" fill-rule="evenodd" data-name="Path 3221" />
                      </g>
                      <g data-name="Group 1033">
                        <path
                          d="m1449.91 2533.591 2.334 2.095a1.557 1.557 0 0 0 .75.373 1.576 1.576 0 0 0 .296.028 1.559 1.559 0 0 0 1.074-.427 1.575 1.575 0 0 0 .09-.093 1.557 1.557 0 0 0 .377-.769 1.563 1.563 0 0 0-.41-1.36 1.588 1.588 0 0 0-.086-.082l-2.333-2.094a1.57 1.57 0 0 0-2.21.119 1.566 1.566 0 0 0-.372.742 1.56 1.56 0 0 0 .49 1.468Z"
                          fill="#fff" fill-rule="evenodd" data-name="Path 3222" />
                      </g>
                    </g>
                  </svg>`
        }

      ],
      dataSliderSection: [{
          title: "Customer Testimonials",
          longText: `In promotion and advertising, a testimonial or show consists of a
            person's written or spoken statement extolling the virtue of a
            product. The term "testimonial" most commonly applies to the
            sales-pitches attributed to ordinary citizens, whereas the word
            "endorsement" usually applies to pitches by celebrities.
            Testimonials can be part of communal marketing. Sometimes, the
            cartoon character can be a testimonial in a commercial.`,
          userImg: "user_photo.png",
          userName: "Sevara Nazarxon",
          userCompany: "CEO of HP, Amazon"
        },
        {
          title: "Customer Testimonials",
          longText: `In promotion and advertising, a testimonial or show consists of a
            person's written or spoken statement extolling the virtue of a
            product. The term "testimonial" most commonly applies to the
            sales-pitches attributed to ordinary citizens, whereas the word
            "endorsement" usually applies to pitches by celebrities.
            Testimonials can be part of communal marketing. Sometimes, the
            cartoon character can be a testimonial in a commercial.`,
          userImg: "user_photo.png",
          userName: "Sevara Nazarxon",
          userCompany: "CEO of HP, Amazon"
        },
        {
          title: "Customer Testimonials",
          longText: `In promotion and advertising, a testimonial or show consists of a
            person's written or spoken statement extolling the virtue of a
            product. The term "testimonial" most commonly applies to the
            sales-pitches attributed to ordinary citizens, whereas the word
            "endorsement" usually applies to pitches by celebrities.
            Testimonials can be part of communal marketing. Sometimes, the
            cartoon character can be a testimonial in a commercial.`,
          userImg: "user_photo.png",
          userName: "Sevara Nazarxon",
          userCompany: "CEO of HP, Amazon"
        },
        {
          title: "Customer Testimonials",
          longText: `In promotion and advertising, a testimonial or show consists of a
            person's written or spoken statement extolling the virtue of a
            product. The term "testimonial" most commonly applies to the
            sales-pitches attributed to ordinary citizens, whereas the word
            "endorsement" usually applies to pitches by celebrities.
            Testimonials can be part of communal marketing. Sometimes, the
            cartoon character can be a testimonial in a commercial.`,
          userImg: "user_photo.png",
          userName: "Sevara Nazarxon",
          userCompany: "CEO of HP, Amazon"
        },
        {
          title: "Customer Testimonials",
          longText: `In promotion and advertising, a testimonial or show consists of a
            person's written or spoken statement extolling the virtue of a
            product. The term "testimonial" most commonly applies to the
            sales-pitches attributed to ordinary citizens, whereas the word
            "endorsement" usually applies to pitches by celebrities.
            Testimonials can be part of communal marketing. Sometimes, the
            cartoon character can be a testimonial in a commercial.`,
          userImg: "user_photo.png",
          userName: "Sevara Nazarxon",
          userCompany: "CEO of HP, Amazon"
        },
      ],
      texnologyData : [
        {
          title: "JavaScript",
          img: require("@/assets/images/icon_javascript.png")
        },
        {
          title: "JavaScript",
          img: require("@/assets/images/dex-synthetic.png")
        },
        {
          title: "JavaScript",
          img: require("@/assets/images/spec_3.png")
        },
        {
          title: "JavaScript",
          img: require("@/assets/images/texnology_img1.png")
        },
        {
          title: "JavaScript",
          img: require("@/assets/images/texnology_img2.png")
        },
         {
          title: "JavaScript",
          img: require("@/assets/images/texnology_img3.png")
        },
         {
          title: "JavaScript",
          img: require("@/assets/images/spec_7.png")
        },
         {
          title: "JavaScript",
          img: require("@/assets/images/texnology_img4.png")
        },
         {
          title: "JavaScript",
          img: require("@/assets/images/texnology_img5.png")
        },
         {
          title: "JavaScript",
          img: require("@/assets/images/texnology_img6.png")
        },
         {
          title: "JavaScript",
          img: require("@/assets/images/spec_11.png")
        },
        {
          title: "JavaScript",
          img: require("@/assets/images/texnology_img7.png")
        },
        {
          title: "JavaScript",
          img: require("@/assets/images/texnology_img8.png")
        },
         {
          title: "JavaScript",
          img: require("@/assets/images/texnology_img9.png")
        },
         {
          title: "JavaScript",
          img: require("@/assets/images/texnology_img10.png")
        },
         {
          title: "JavaScript",
          img: require("@/assets/images/texnology_img11.png")
        },
         {
          title: "JavaScript",
          img: require("@/assets/images/texnology_img12.png")
        },
          {
          title: "JavaScript",
          img: require("@/assets/images/texnology_img13.png")
        },
      ]
    }),
  }
</script>

<style lang="scss">
  .heroSection {
    background-image: url("../assets/images/img_bacground_4.png"), url("../assets/images/img_bacground_1.png");
    background-size: 575px, 1025px;
    background-repeat: no-repeat;
    background-position: top left, top 2px right;
    margin-top: -95px;

    .heroWrapper {
      padding-top: 64px;
      padding-bottom: 150px;

      .heroBody {
        margin-top: 195px;
        display: flex;
        padding: 0 10px;
        justify-content: space-between;

        div {
          h1 {
            margin-top: 72.5px;
            font-size: 56px;
            line-height: 72px;
            font-family: "HelveticaNeueCyr";
            font-weight: 600;
            max-width: 400px;
            position: relative;
            margin-left: 15.4px;
          }

          h1::before {
            content: "";
            background-image: url("../assets/images/dots_hero.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            left: -16.9%;
            top: 28.5%;
            width: 198px;
            height: 177px;
          }

          h1::after {
            content: "";
            background-image: url("../assets/images/bacground_hero_2.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            width: 240px;
            height: 240px;
            top: -50%;
            left: 40%;
            z-index: -1;
          }

          p {
            margin-top: 17px;
            max-width: 750px;
            font-size: 24px;
            margin-left: 15.5px;
            line-height: 32px;
          }
        }

        div {
          img:nth-child(2) {
            position: fixed;
            bottom: 20.4%;
            right: 6.35%;
            width: 88px;
            height: 88px;
            z-index: 5000;
            animation: animateCallImg 7s;
            animation-iteration-count: infinite;
          }
          img:nth-child(2):hover {
              cursor: pointer;
          }
          img:nth-child(1) {
            margin-top: -4px;
            margin-right: -1.5px;
            width: 630px;
          }
        }

      }
    }
  }

  .pixyzEasysection {
    background-image: url("../assets/images/img_bacground_3.png"), url("../assets/images/img_bacground_2.png");
    background-size: 1040px, 1025px;
    background-repeat: no-repeat;
    background-position: top left, top right;
    padding: 110px;

    .pixyzEasywrapper {
      .pixyzEasybody {
        text-align: center;
        padding-top: 80px;

        h1 {
          font-size: 40px;
          color: #217a73;
          font-family: "HelveticaNeueCyr";
          font-weight: bold;
          font-style: normal;
          padding-bottom: 22px;
          margin-left: -33px;
          margin-top: 8.5px;
          letter-spacing: -0.3px;
        }

        p {
          font-size: 24px;
          color: #8a8a8a;
          max-width: 1360px;
          font-family: "HelveticaNeueCyr";
          margin: 0 auto;
          text-align: left;
          line-height: 40px;
          padding-bottom: 260px;
          padding-left: 6px;
          margin-top: 5px;
          position: relative;
        }

        p::before {
          content: "";
          background-image: url("../assets/images/Component 2 – 1.png");
          position: absolute;
          background-size: contain;
          background-repeat: no-repeat;
          top: 39.3%;
          left: 40.5%;
          width: 470px;
          height: 470px;
        }
      }
    }
  }

  .servicessection {
    background-color: #f4f6fc;
    margin-top: -77px;

    .serviceswrapper {
      .servicesbody {
        text-align: center;
        padding-top: 71px;

        h3 {
          font-size: 40px;
          color: #217a73;
          font-weight: 400;
          font-family: "HelveticaNeueCyr";
          font-weight: bold;
          margin-left: -20px;
          letter-spacing: -0.6px;
        }

        p {
          color: #7d7d7d;
          max-width: 1060px;
          line-height: 40px;
          margin: 0 auto;
          font-size: 24px;
          padding-top: 20px;
          margin-top: 8px;
          padding-left: 9.5px;
        }

        li:hover {
          div {
            background-color: #fff;
            svg path {
              fill: #49d6cb !important;
            }
          }
        }

        ul::before {
          content: "";
          background-image: url("../assets/images/servis_bacground.png");
          position: absolute;
          background-size: contain;
          background-repeat: no-repeat;
          bottom: -19%;
          right: 11.5%;
          width: 270px;
          height: 270px;
        }

        div {
          img {
            margin-bottom: -43px;
            margin-top: -10px;
            margin-left: 16px;
          }
        }
      }
    }
  }

  .workLineSection {
    .workLineWrapper {
      .workLineBody {
        margin-top: 90px;

        h3 {
          text-align: center;
          font-size: 39px;
          color: #217a73;
          font-family: "HelveticaNeueCyr";
          font-weight: 600;
          word-spacing: 0px;
          letter-spacing: 0.7px;
          margin-left: 14px;
        }

        ul {
          li {
            display: flex;
            position: relative;
            justify-content: space-around;
            margin: 150px 170px;
            padding-left: 105px;
            margin-bottom: 280px;
            img {
                margin-left: 2px;
                margin-top: 0.25px;
            }
            div {
              margin-top: 6.5%;
              margin-left: -0.5%;

              h4 {
                font-size: 32px;
                color: #217a73;
                letter-spacing: -0.8px;
                font-family: "HelveticaNeueCyr";
                font-weight: bold;
                margin-top: 2px;
                margin-left: 1px;
              }

              p {
                color: #8a8a8a;
                max-width: 670px;
                font-size: 24px;
                margin-left: 2px;
                line-height: 1.67;
                margin-top: 27px;
              }
            }
          }

          li:nth-child(2n) {
            display: flex;
            flex-direction: row-reverse;
            padding-left: 0;

            img {
              height: 298px;
              margin-right: -3px;
              margin-top: -0px;
            }

            div {
              margin-top: 0.3%;
              margin-left: -2.5%;

              h4 {
                font-size: 31px;
                margin-left: 1px;
                letter-spacing: 0.1px;
                font-weight: bolder;
                color: #217a73;
                font-family: "HelveticaNeueCyr";
                font-weight: 700;
              }

              p {
                color: #8a8a8a;
                max-width: 680px;
                font-size: 24px;
                line-height: 1.66;
                margin-left: 1.5px;
                margin-top: 27px;
              }
            }
          }

          li:nth-child(3) {
            display: flex;
            position: relative;
            justify-content: space-around;
            margin: 150px 170px;
            padding-left: 93px;
            margin-bottom: 107px;
            margin-top: -37px;
            img {
              margin-left: 9px;
              margin-top: 1px;
            }
            div {
              margin-top: 5.5%;
              margin-left: 6%;

              h4 {
                font-size: 33px;
                color: #217a73;
                font-family: "HelveticaNeueCyr";
                font-weight: bold;
                margin-left: 9px;
                margin-top: -0px;
              }

              p {
                color: #8a8a8a;
                max-width: 690px;
                font-size: 24px;
                line-height: 1.66;
                margin-top: 28px;
                padding-left: 8px;
              }
            }
          }

          li:nth-child(1):after {
            content: "";
            background-image: url("../assets/images/Group 1580.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            top: -34%;
            left: 44%;
            width: 285px;
            height: 285px;
          }

          li:nth-child(2):after {
            content: "";
            background-image: url("../assets/images/Group 1582.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            top: -119%;
            margin-left: -5px;
            width: 1200px;
            height: 400px;
          }

          li:nth-child(3):after {
            content: "";
            background-image: url("../assets/images/Group 1583.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            top: -55%;
            right: 11.2%;
            width: 600px;
            height: 300px;
          }

          li:nth-child(3):before {
            content: "";
            background-image: url("../assets/images/Group 1584.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            top: 84%;
            right: -1.2%;
            width: 750px;
            height: 180px;
          }
        }

        a {
          display: inline-block;
          color: #fff;
          font-size: 16px;
          background-color: #49d6cb;
          padding: 14.5px 52.2px;
          border-radius: 5px;
          margin-left: 44.83%;
          border: 1px solid transparent;
          transition: all 0.5s;
        }

        a:hover {
          color: #49d6cb;
          border: 1px solid #49d6cb;
          background-color: #fff;
        }
      }
    }
  }

  .texnologySection {
    .texnologyWrapper {
      .texnologyBody {
        margin-top: 75px;

        h3 {
          font-size: 39px;
          color: #217a73;
          text-align: center;
          position: relative;
          font-family: 'HelveticaNeueCyr';
          font-weight: bold;
          letter-spacing: -0.1px;
          margin-left: -55px;
        }

        p {
          color: #7d7d7d;
          font-size: 23.8px;
          max-width: 1410px;
          margin: 0 auto;
          padding: 52px 0px;
          padding-left: 30px;
          line-height: 40px;
        }

        h3:before {
          content: "";
          background-image: url("../assets/images/servis_bacground.png");
          position: absolute;
          background-size: contain;
          background-repeat: no-repeat;
          width: 280px;
          left: 10.5%;
          top: 30px;
          height: 280px;
          z-index: -2;
        }

        ul {
          display: flex;
          flex-wrap: wrap;
          width: 85%;
          margin: 0 auto;
          padding-left: 60px;
          margin-top: -10px;
          margin-bottom: 7px;
          li {
            width: 110px;
            height: 120px;
            margin: 12px 14.5px;
            border-radius: 5px;
            background-color: #fff;
            border: 1px solid transparent;

            position: relative;
            img {
                display: block;
                margin: 0 auto; 
                margin-top: 13px;             
            }

            p {
              font-size: 14px;
              color: #fff;
              text-align: center;
              position: absolute;
              bottom: -50px;
              left: -5px;
            }

            transition: all 0.5s;
          }

          li:hover {
            box-shadow: 0px 0px 15px 5px rgba(0, 0, 0, 0.1607843137254902);
            border: 1px solid rgba(0, 0, 0, 0.1607843137254902);
            cursor: pointer;
            p {
              color: #000;
            }
          }
        }
      }
    }
  }

  .sliderSection {
    background-color: #f4f6fc;
    margin-top: 65px;
    height: 700px;
  }

  .postUserSection {
    .postUserWrapper {
      .postUserBody {
        max-width: 1367px;
        margin: 0 auto;
        -webkit-box-shadow: 0px 0px 20px 2px rgba(117, 117, 117, 0.161);
        box-shadow: 0px 0px 20px 2px rgba(117, 117, 117, 0.161);
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        margin-top: 86px;
        margin-left: 205px;
        .post_user_left {
          width: 915px;
          padding: 10px;

          h3 {
            color: #217a73;
            font-size: 31px;
            margin-top: 50px;
            word-spacing: 1.5px;
            margin-left: 60px;
          }

          form {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-wrap: wrap;
            flex-wrap: wrap;
            margin-left: 45px;
            margin-top: 25px;
            width: 786px;

            input {
              margin: 10px 14.5px;
              margin-left: 12px;
              padding: 19.5px;
              width: 354px;
              border: none;
              border: 1px solid #49d6cb !important;
              color: #c9c9c9 !important;
            }
            input::placeholder {
              color: #c9c9c9 !important;
            }
            select {
              padding: 20px;
              width: 354px;
              color: #c9c9c9;
              margin: 10px 14px;
              border: none;
              border: 1px solid #49d6cb;
              background-color: inherit !important;
              position: relative;
              overflow: hidden;
              overflow: -moz-hidden-unscrollable;
              background: url("@/assets/images/selectDownImg.png") no-repeat right;
              background-position: top 20.5px right 21px;
              display: inline-block;
              position: relative;
            }
            textarea {
              width: 740px;
              margin: 10px;
              padding: 20px 28px;
              height: 185px;
              text-align: left;
              border: none;
              color: #c9c9c9;
              border: 1px solid #49d6cb;
              background-color: inherit !important;
              resize: none;
            }
            textarea::placeholder {
              color: #c9c9c9;
            }
            button {
              background-color: #49d6cb;
              display: block;
              border: 1px solid #fff;
              padding: 15.5px 59px;
              color: #fff;
              margin: 17px 14px;
              margin-bottom: 25px;
              -webkit-transition: all 0.5s;
              transition: all 0.5s;
            }

            button:hover {
              background-color: #fff;
              color: #49d6cb;
              border: 1px solid #49d6cb;
            }
          }
        }

        .post_user_right {
          background-image: url("../assets/images/img_post.png");
          background-position: bottom 10px right 20px;
          background-repeat: no-repeat;
          background-size: 315px;
          background-color: #49d6cb;
          width: 536px;
          padding-left: 75px;
          padding-top: 15px;

          h3 {
            color: #fff;
            font-size: 32px;
            font-weight: 600;
            margin-top: 45px;
          }

          a {
            display: block;
            color: #fff;
            font-size: 16px;
            font-weight: normal;
            margin-top: 46.3px;
            padding-bottom: 15px;
          }
        }

      }
    }
  }

  @keyframes animateCallImg {
    0% {
      transform: scale(1);
    }

    50% {
      transform: scale(1.5);
    }

    100% {
      transform: scale(1);
    }
  }

  @media only screen and (max-width: 1900px) {
    .heroSection {
    background-image: url("../assets/images/img_bacground_4.png"), url("../assets/images/img_bacground_1.png");
    background-size: 575px, 1025px;
    background-repeat: no-repeat;
    background-position: top left, top 2px right;
    margin-top: -95px;

    .heroWrapper {
      padding-top: 64px;
      padding-bottom: 148px;

      .heroBody {
        margin-top: 195px;
        display: flex;
        padding: 0 10px;
        justify-content: space-between;

        div {
          h1 {
            margin-top: 72.5px;
            font-size: 56px;
            line-height: 72px;
            font-family: "HelveticaNeueCyr";
            font-weight: 600;
            max-width: 400px;
            position: relative;
            margin-left: 15.4px;
          }

          h1::before {
            content: "";
            background-image: url("../assets/images/dots_hero.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            left: -16.9%;
            top: 28.5%;
            width: 198px;
            height: 177px;
          }

          h1::after {
            content: "";
            background-image: url("../assets/images/bacground_hero_2.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            width: 240px;
            height: 240px;
            top: -50%;
            left: 40%;
            z-index: -1;
          }

          p {
            margin-top: 17px;
            max-width: 750px;
            font-size: 24px;
            margin-left: 15.5px;
            line-height: 32px;
          }
        }

        div {
          img:nth-child(2) {
            position: fixed;
            bottom: 20.4%;
            right: 6.35%;
            width: 88px;
            height: 88px;
            z-index: 5000;
            animation: animateCallImg 7s;
            animation-iteration-count: infinite;
          }
          img:nth-child(2):hover {
              cursor: pointer;
          }
          img:nth-child(1) {
            margin-top: -4px;
            margin-right: -1.5px;
            width: 630px;
          }
        }

      }
    }
    }
    .pixyzEasysection {
      background-image: url("../assets/images/img_bacground_3.png"), url("../assets/images/img_bacground_2.png");
      background-size: 1030px, 1025px;
      background-repeat: no-repeat;
      background-position: top left, top right;
      padding: 150px;

      .pixyzEasywrapper {
        .pixyzEasybody {
          text-align: center;
          padding-top: 80px;

          h1 {
            font-size: 40px;
            color: #217a73;
            padding-bottom: 20px;
          }

          p {
            font-size: 24px;
            color: #8a8a8a;
            max-width: 1200px;
            margin: 0 auto;
            line-height: 1.5;
            padding-bottom: 260px;
            position: relative;
          }

          p::before {
            content: "";
            background-image: url("../assets/images/Component 2 – 1.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            top: 45%;
            left: 40%;
            width: 400px;
            height: 450px;
          }
        }
      }
    }
    .servicessection {
      background-color: #f4f6fc;
      margin-top: -206px;

      .serviceswrapper {
        .servicesbody {
          text-align: center;
          padding-top: 80px;

          h3 {
            font-size: 40px;
            color: #217a73;
            font-weight: 400;
          }

          p {
            color: #7d7d7d;
            max-width: 950px;
            line-height: 1.5;
            margin: 0 auto;
            font-size: 24px;
            padding-top: 20px;
          }

          ul::before {
            content: "";
            background-image: url("../assets/images/servis_bacground.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            bottom: -15%;
            right: 4%;
            width: 270px;
            height: 270px;
          }

          div {
            img {
              margin-bottom: -40px;
            }
          }
        }
      }
    }
    .workLineSection {
      .workLineWrapper {
        .workLineBody {
          margin-top: 95px;

          h3 {
            text-align: center;
            font-size: 39px;
            color: #217a73;
            font-weight: 400;
            font-family: "HelveticaNeueCyr";
            font-weight: 600;
            word-spacing: -2px;
            margin-left: 15px;
          }

          ul {
            li {
              display: flex;
              position: relative;
              justify-content: space-around;
              margin: 150px 0px;
              padding-left: 55px;
              margin-bottom: 280px;

              div {
                margin-top: 6.5%;
                margin-left: 5%;
                h4 {
                  font-size: 33px;
                  color: #217a73;
                  font-family: "HelveticaNeueCyr";
                  font-weight: 400;
                  font-weight: 400;
                }

                p {
                  color: #8a8a8a;
                  max-width: 670px;
                  font-size: 24px;
                  line-height: 1.65;
                  margin-top: 30px;
                }
              }
            }

            li:nth-child(2n) {
              display: flex;
              flex-direction: row-reverse;
              padding-left: 0;

              img {
                height: 300px;
                margin-left: -0px;
              }

              div {
                margin-top: 0.3%;
                margin-left: -5%;

                h4 {
                  font-size: 33px;
                  font-weight: bolder;
                  color: #217a73;
                  font-weight: 400;
                  font-family: "HelveticaNeueCyr";
                  font-weight: 400;
                }

                p {
                  color: #8a8a8a;
                  max-width: 680px;
                  font-size: 24px;
                  line-height: 1.66;
                  margin-left: 0px;
                  margin-top: 28px;
                }
              }
            }

            li:nth-child(3) {
              display: flex;
              position: relative;
              justify-content: space-around;
              margin: 150px 0px;
              padding-left: 93px;
              margin-bottom: 107px;
              margin-top: -37px;

              div {
                margin-top: 5.5%;
                margin-left: 8%;

                h4 {
                  font-size: 33.5px;
                  color: #217a73;
                  font-family: "HelveticaNeueCyr";
                  font-weight: 400;
                  margin-left: -3px;
                }

                p {
                  color: #8a8a8a;
                  max-width: 685px;
                  font-size: 24px;
                  line-height: 1.65;
                  margin-top: 30px;
                }
              }
            }

            li:nth-child(1):after {
              content: "";
              background-image: url("../assets/images/Group 1580.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: -34%;
              left: 44%;
              width: 285px;
              height: 285px;
            }

            li:nth-child(2):after {
              content: "";
              background-image: url("../assets/images/Group 1582.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: -119%;
              margin-left: -5px;
              width: 1200px;
              height: 400px;
            }

            li:nth-child(3):after {
              content: "";
              background-image: url("../assets/images/Group 1583.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: -55%;
              right: 11.2%;
              width: 500px;
              height: 250px;
            }

            li:nth-child(3):before {
              content: "";
              background-image: url("../assets/images/Group 1584.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: 90%;
              right: -1.2%;
              width: 590px;
              height: 300px;
            }
          }

          a {
            display: inline-block;
            color: #fff;
            font-size: 16px;
            background-color: #49d6cb;
            padding: 14.5px 52.2px;
            border-radius: 5px;
            margin-left: 44.63%;
            border: 1px solid transparent;
            transition: all 0.5s;
          }

          a:hover {
            color: #49d6cb;
            border: 1px solid #49d6cb;
            background-color: #fff;
          }
        }
      }
    }
    .texnologySection {
    .texnologyWrapper {
      .texnologyBody {
        margin-top: 75px;

        h3 {
          font-size: 39px;
          color: #217a73;
          text-align: center;
          position: relative;
          font-family: 'HelveticaNeueCyr';
          font-weight: bold;
          letter-spacing: -0.1px;
          margin-left: -55px;
        }

        p {
          color: #7d7d7d;
          font-size: 23.8px;
          max-width: 1410px;
          margin: 0 auto;
          padding: 52px 0px;
          padding-left: 30px;
          line-height: 40px;
        }

        h3:before {
          content: "";
          background-image: url("../assets/images/servis_bacground.png");
          position: absolute;
          background-size: contain;
          background-repeat: no-repeat;
          width: 280px;
          left: 10.5%;
          top: 30px;
          height: 280px;
          z-index: -2;
        }

        ul {
          display: flex;
          flex-wrap: wrap;
          width: 85%;
          margin: 0 auto;
          padding-left: 60px;
          margin-top: -10px;
          margin-bottom: 7px;
          li {
            width: 110px;
            height: 120px;
            margin: 12px 14.5px;
            border-radius: 5px;
            background-color: #fff;
            border: 1px solid transparent;

            position: relative;
            img {
                display: block;
                margin: 0 auto; 
                margin-top: 13px;             
            }

            p {
              font-size: 14px;
              color: #fff;
              text-align: center;
              position: absolute;
              bottom: -50px;
              left: -5px;
            }

            transition: all 0.5s;
          }

          li:hover {
            box-shadow: 0px 0px 15px 5px rgba(0, 0, 0, 0.1607843137254902);
            border: 1px solid rgba(0, 0, 0, 0.1607843137254902);
            cursor: pointer;
            p {
              color: #000;
            }
          }
        }
      }
    }
  }
    .postUserSection {
      .postUserWrapper {
        .postUserBody {
          max-width: 1380px;
          margin: 0 auto;
          -webkit-box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.160784);
          box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.160784);
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          margin-top: 88px;

          .post_user_left {
            width: 700px;
            padding: 20px;

            h3 {
              color: #217a73;
              font-size: 30px;
              margin-top: 25px;
              margin-left: 60px;
            }

            form {
              display: -webkit-box;
              display: -ms-flexbox;
              display: flex;
              -ms-flex-wrap: wrap;
              flex-wrap: wrap;
              margin-left: 25px;
              margin-top: 20px;
              width: 786px;

              input {
                margin: 11px 10px;
                padding: 20px;
                width: 300px;
                border: none;
                border: 1px solid #49d6cb !important;
                color: #c9c9c9 !important;
              }

              select {
                padding: 20px;
                width: 300px;
                color: #c9c9c9;
                margin: 7px 10px;
                border: none;
                border: 1px solid #49d6cb;
                background-color: inherit !important;
              }

              textarea {
                width: 620px;
                margin: 10px;
                padding: 20px 28px;
                height: 185px;
                text-align: left;
                border: none;
                color: #c9c9c9;
                border: 1px solid #49d6cb;
                background-color: inherit !important;
                resize: none;
              }

              button {
                background-color: #49d6cb;
                display: block;
                border: 1px solid #fff;
                padding: 15.5px 59px;
                color: #fff;
                margin: 19.1px 15px;
                -webkit-transition: all 0.5s;
                transition: all 0.5s;
              }

              button:hover {
                background-color: #fff;
                color: #49d6cb;
                border: 1px solid #49d6cb;
              }
            }
          }

          .post_user_right {
            background-image: url("../assets/images/img_post.png");
            background-position: bottom 10px right 20px;
            background-repeat: no-repeat;
            background-size: 320px;
            background-color: #49d6cb;
            width: 650px;
            padding-left: 25px;
            padding-top: 0px;

            h3 {
              color: #fff;
              font-size: 32px;
              font-weight: 500;
              margin-top: 45px;
            }

            a {
              display: block;
              color: #fff;
              font-size: 16px;
              font-weight: normal;
              margin-top: 47px;
              padding-bottom: 15px;
            }
          }

        }
      }
    }
  }

  @media only screen and (max-width: 1750px) {
     .heroSection {
    background-image: url("../assets/images/img_bacground_4.png"), url("../assets/images/img_bacground_1.png");
    background-size: 570px, 1030px;
    background-repeat: no-repeat;
    background-position: top left, top right;
    margin-top: -95px;

    .heroWrapper {
      padding-top: 60px;
      padding-bottom: 140px;

      .heroBody {
        margin-top: 195px;
        display: flex;
        padding: 0 10px;
        justify-content: space-between;

        div {
          h1 {
            margin-top: 9.5%;
            font-size: 52px;
            line-height: 75px;
            font-family: "HelveticaNeueCyr";
            font-weight: 600;
            max-width: 400px;
            position: relative;
            margin-left: 10px;
          }

          h1::before {
            content: "";
            background-image: url("../assets/images/dots_hero.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            left: -16.5%;
            top: 30%;
            width: 190px;
            height: 177px;
          }

          h1::after {
            content: "";
            background-image: url("../assets/images/bacground_hero_2.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            width: 250px;
            height: 250px;
            top: -50%;
            left: 40%;
            z-index: -1;
          }

          p {
            margin-top: 12px;
            max-width: 750px;
            font-size: 24px;
            margin-left: 10px;
            line-height: 31px;
          }
        }

        div {
          img:nth-child(2) {
            position: fixed;
            bottom: 20.4%;
            right: 6.35%;
            width: 88px;
            height: 88px;
            z-index: 5000;
            animation: animateCallImg 7s;
            animation-iteration-count: infinite;
          }
        }

      }
    }
  }

    .pixyzEasysection {
    background-image: url("../assets/images/img_bacground_3.png"), url("../assets/images/img_bacground_2.png");
    background-size: 1040px, 1033px;
    background-repeat: no-repeat;
    background-position: top left, top right;
    padding: 110px;

    .pixyzEasywrapper {
      .pixyzEasybody {
        text-align: center;
        padding-top: 80px;

        h1 {
          font-size: 40px;
          color: #217a73;
          font-family: "comfortaa";
          padding-bottom: 22px;
          margin-left: -9px;
          letter-spacing: 2px;
        }

        p {
          font-size: 24px;
          color: #8a8a8a;
          max-width: 1360px;
          font-family: "HelveticaNeueCyr";
          margin: 0 auto;
          text-align: left;
          line-height: 40.9px;
          padding-bottom: 260px;
          position: relative;
        }

        p::before {
          content: "";
          background-image: url("../assets/images/Component 2 – 1.png");
          position: absolute;
          background-size: contain;
          background-repeat: no-repeat;
          top: 40%;
          left: 40%;
          width: 470px;
          height: 470px;
        }
      }
    }
  }


  .servicessection {
    background-color: #f4f6fc;
    margin-top: -155px;

    .serviceswrapper {
      .servicesbody {
        text-align: center;
        padding-top: 90px;

        h3 {
          font-size: 40px;
          color: #217a73;
          font-weight: 400;
          font-family: "comfortaa";
          font-weight: bold;

        }

        p {
          color: #7d7d7d;
          max-width: 1050px;
          line-height: 40px;
          margin: 0 auto;
          font-size: 24px;
          padding-top: 20px;
          margin-top: 5px;

        }

        li:hover {
          div {
            background-color: #fff;

            svg path {
              fill: #49d6cb !important;
            }
          }
        }

        ul::before {
          content: "";
          background-image: url("../assets/images/servis_bacground.png");
          position: absolute;
          background-size: contain;
          background-repeat: no-repeat;
          bottom: -19%;
          right: 11.5%;
          width: 270px;
          height: 270px;
        }

        div {
          img {
            margin-bottom: -50px;
            margin-top: 11px;
            margin-left: 9px;
          }
        }
      }
    }
  }

    .workLineSection {
      .workLineWrapper {
        .workLineBody {
          margin-top: 100px;

          h3 {
            text-align: center;
            font-size: 40px;
            color: #217a73;
            font-weight: 400;
          }

          ul {
            li {
              display: flex;
              position: relative;
              justify-content: space-around;
              margin: 150px 0;

              div {
                margin-top: 5%;

                h4 {
                  font-size: 32px;
                  color: #217a73;
                  font-weight: 400;
                }

                p {
                  color: #8a8a8a;
                  max-width: 640px;
                  font-size: 24px;
                  line-height: 1.4;
                  margin-top: 20px;
                }
              }
            }

            li:nth-child(2n) {
              display: flex;
              flex-direction: row-reverse;
            }

            li:nth-child(1):after {
              content: "";
              background-image: url("../assets/images/Group 1580.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: -30%;
              width: 270px;
              height: 270px;
            }

            li:nth-child(2):after {
              content: "";
              background-image: url("../assets/images/Group 1582.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: -100%;
              width: 1050px;
              height: 400px;
            }

            li:nth-child(3):after {
              content: "";
              background-image: url("../assets/images/Group 1583.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: -40%;
              right: 18%;
              width: 450px;
              height: 300px;
            }

            li:nth-child(3):before {
              content: "";
              background-image: url("../assets/images/Group 1584.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: 85%;
              right: -10%;
              width: 700px;
              height: 200px;
            }
          }

          a {
            color: #fff;
            font-size: 16px;
            background-color: #49d6cb;
            padding: 15px 50px;
            border-radius: 10px;
            margin-left: 44%;
          }
        }
      }
    }

    .texnologySection {
    .texnologyWrapper {
      .texnologyBody {
        margin-top: 75px;

        h3 {
          font-size: 39px;
          color: #217a73;
          text-align: center;
          position: relative;
          font-family: 'HelveticaNeueCyr';
          font-weight: bold;
          letter-spacing: -0.1px;
          margin-left: -55px;
        }

        p {
          color: #7d7d7d;
          font-size: 23.8px;
          max-width: 1410px;
          margin: 0 auto;
          padding: 52px 0px;
          padding-left: 30px;
          line-height: 40px;
        }

        h3:before {
          content: "";
          background-image: url("../assets/images/servis_bacground.png");
          position: absolute;
          background-size: contain;
          background-repeat: no-repeat;
          width: 280px;
          left: 10.5%;
          top: 30px;
          height: 280px;
          z-index: -2;
        }

        ul {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          margin: 0 auto;
          padding-left: 0px;
          margin-top: -10px;
          margin-bottom: 7px;
          li {
            width: 110px;
            height: 120px;
            margin: 12px 14.5px;
            border-radius: 5px;
            background-color: #fff;
            border: 1px solid transparent;

            position: relative;
            img {
                display: block;
                margin: 0 auto; 
                margin-top: 13px;             
            }

            p {
              font-size: 14px;
              color: #fff;
              text-align: center;
              position: absolute;
              bottom: -50px;
              left: -5px;
            }

            transition: all 0.5s;
          }

          li:hover {
            box-shadow: 0px 0px 15px 5px rgba(0, 0, 0, 0.1607843137254902);
            border: 1px solid rgba(0, 0, 0, 0.1607843137254902);
            cursor: pointer;
            p {
              color: #000;
            }
          }
        }
      }
    }
  }

    .sliderSection {
      background-color: #f4f6fc;
    }

    .postUserSection {
      .postUserWrapper {
        .postUserBody {
          max-width: 1380px;
          margin: 0 auto;
          -webkit-box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.160784);
          box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.160784);
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          margin-top: 88px;

          .post_user_left {
            width: 700px;
            padding: 20px;

            h3 {
              color: #217a73;
              font-size: 30px;
              margin-top: 25px;
              margin-left: 60px;
            }

            form {
              display: -webkit-box;
              display: -ms-flexbox;
              display: flex;
              -ms-flex-wrap: wrap;
              flex-wrap: wrap;
              margin-left: 25px;
              margin-top: 20px;
              width: 786px;

              input {
                margin: 11px 10px;
                padding: 20px;
                width: 300px;
                border: none;
                border: 1px solid #49d6cb !important;
                color: #c9c9c9 !important;
              }

              select {
                padding: 20px;
                width: 300px;
                color: #c9c9c9;
                margin: 7px 10px;
                border: none;
                border: 1px solid #49d6cb;
                background-color: inherit !important;
              }

              textarea {
                width: 620px;
                margin: 10px;
                padding: 20px 28px;
                height: 185px;
                text-align: left;
                border: none;
                color: #c9c9c9;
                border: 1px solid #49d6cb;
                background-color: inherit !important;
                resize: none;
              }

              button {
                background-color: #49d6cb;
                display: block;
                border: 1px solid #fff;
                padding: 15.5px 59px;
                color: #fff;
                margin: 19.1px 15px;
                -webkit-transition: all 0.5s;
                transition: all 0.5s;
              }

              button:hover {
                background-color: #fff;
                color: #49d6cb;
                border: 1px solid #49d6cb;
              }
            }
          }

          .post_user_right {
            background-image: url("../assets/images/img_post.png");
            background-position: bottom 10px right 20px;
            background-repeat: no-repeat;
            background-size: 320px;
            background-color: #49d6cb;
            width: 500px;
            padding-left: 25px;
            padding-top: 0px;

            h3 {
              color: #fff;
              font-size: 32px;
              font-weight: 500;
              margin-top: 45px;
            }

            a {
              display: block;
              color: #fff;
              font-size: 16px;
              font-weight: normal;
              margin-top: 47px;
              padding-bottom: 15px;
            }
          }

        }
      }
    }
  }

  @media only screen and (max-width: 1500px) {
    .heroSection {
      background-image: url("../assets/images/img_bacground_4.png"), url("../assets/images/img_bacground_1.png");
      background-size: 450px, 900px;
      background-repeat: no-repeat;
      background-position: top left, top right;
      margin-top: -90px;

      .heroWrapper {
        padding-top: 60px;
        padding-bottom: 180px;

        .heroBody {
          margin-top: 180px;
          display: flex;
          justify-content: space-between;

          div {
            h1 {
              margin-top: 10%;
              font-size: 50px;
              line-height: 55px;
              max-width: 400px;
              position: relative;
            }

            h1::before {
              content: "";
              background-image: url("../assets/images/dots_hero.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              left: -10%;
              top: 35%;
              width: 120px;
              height: 120px;
            }

            h1::after {
              content: "";
              background-image: url("../assets/images/bacground_hero_2.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              width: 200px;
              height: 200px;
              top: -55%;
              left: 35%;
              z-index: -1;
            }

            p {
              margin-top: 10px;
              max-width: 600px;
              font-size: 20px;
            }
          }

          div {
            img:nth-child(1) {
              width: 450px;
            }

            img:nth-child(2) {
              position: fixed;
              bottom: 2%;
              right: 3%;
              z-index: 50000;
              animation: animateCallImg 7s;
              animation-iteration-count: infinite;
            }
          }

        }
      }
    }
    .servicessection {
      background-color: #f4f6fc;
      margin-top: -145px;

      .serviceswrapper {
        .servicesbody {
          text-align: center;
          padding-top: 50px;

          h3 {
            font-size: 40px;
            color: #217a73;
            font-weight: 400;
          }

          p {
            color: #7d7d7d;
            max-width: 950px;
            line-height: 1.5;
            margin: 0 auto;
            font-size: 24px;
            padding-top: 20px;
          }


          ul::before {
            content: "";
            background-image: url("../assets/images/servis_bacground.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            bottom: -15%;
            right: 4%;
            width: 270px;
            height: 270px;
          }

          div {
            img {
              margin-bottom: -50px;
            }
          }
        }
      }
    }
    .postUserSection {
      .postUserWrapper {
        .postUserBody {
          max-width: 1380px;
          margin: 0 auto;
          -webkit-box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.160784);
          box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.160784);
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          margin-top: 88px;

          .post_user_left {
            width: 700px;
            padding: 20px;

            h3 {
              color: #217a73;
              font-size: 30px;
              margin-top: 25px;
              margin-left: 60px;
            }

            form {
              display: -webkit-box;
              display: -ms-flexbox;
              display: flex;
              -ms-flex-wrap: wrap;
              flex-wrap: wrap;
              margin-left: 25px;
              margin-top: 20px;
              width: 786px;

              input {
                margin: 11px 10px;
                padding: 20px;
                width: 300px;
                border: none;
                border: 1px solid #49d6cb !important;
                color: #c9c9c9 !important;
              }

              select {
                padding: 20px;
                width: 300px;
                color: #c9c9c9;
                margin: 7px 10px;
                border: none;
                border: 1px solid #49d6cb;
                background-color: inherit !important;
              }

              textarea {
                width: 620px;
                margin: 10px;
                padding: 20px 28px;
                height: 185px;
                text-align: left;
                border: none;
                color: #c9c9c9;
                border: 1px solid #49d6cb;
                background-color: inherit !important;
                resize: none;
              }

              button {
                background-color: #49d6cb;
                display: block;
                border: 1px solid #fff;
                padding: 15.5px 59px;
                color: #fff;
                margin: 19.1px 15px;
                -webkit-transition: all 0.5s;
                transition: all 0.5s;
              }

              button:hover {
                background-color: #fff;
                color: #49d6cb;
                border: 1px solid #49d6cb;
              }
            }
          }

          .post_user_right {
            background-image: url("../assets/images/img_post.png");
            background-position: bottom 10px right 20px;
            background-repeat: no-repeat;
            background-size: 320px;
            background-color: #49d6cb;
            width: 500px;
            padding-left: 25px;
            padding-top: 0px;

            h3 {
              color: #fff;
              font-size: 32px;
              font-weight: 500;
              margin-top: 45px;
            }

            a {
              display: block;
              color: #fff;
              font-size: 16px;
              font-weight: normal;
              margin-top: 47px;
              padding-bottom: 15px;
            }
          }

        }
      }
    }
     .pixyzEasysection {
    background-image: url("../assets/images/img_bacground_3.png"), url("../assets/images/img_bacground_2.png");
    background-size: 900px, 900px;
    background-repeat: no-repeat;
    background-position: top left, top right;
    padding: 110px;

    .pixyzEasywrapper {
      .pixyzEasybody {
        text-align: center;
        padding-top: 40px;

        h1 {
          font-size: 35px;
          color: #217a73;
          font-family: "comfortaa";
          padding-bottom: 22px;
          margin-left: -9px;
          letter-spacing: 2px;
        }

        p {
          font-size: 20px;
          color: #8a8a8a;
          max-width: 1360px;
          font-family: "HelveticaNeueCyr";
          margin: 0 auto;
          text-align: left;
          line-height: 40.9px;
          padding-bottom: 260px;
          position: relative;
        }

        p::before {
          content: "";
          background-image: url("../assets/images/Component 2 – 1.png");
          position: absolute;
          background-size: contain;
          background-repeat: no-repeat;
          top: 40%;
          left: 40%;
          width: 400px;
          height: 400px;
        }
      }
    }
    }
    .workLineSection {
        .workLineWrapper {
          .workLineBody {
            margin-top: 95px;

            h3 {
              text-align: center;
              font-size: 39px;
              color: #217a73;
              font-weight: 400;
              font-family: "HelveticaNeueCyr";
              font-weight: 600;
              word-spacing: -2px;
              margin-left: 15px;
            }

            ul {
              li {
                display: flex;
                position: relative;
                justify-content: space-around;
                margin: 150px 0px;
                padding-left: 55px;
                margin-bottom: 280px;

                div {
                  margin-top: 6.5%;
                  margin-left: 5%;
                  h4 {
                    font-size: 33px;
                    color: #217a73;
                    font-family: "HelveticaNeueCyr";
                    font-weight: 400;
                    font-weight: 400;
                  }

                  p {
                    color: #8a8a8a;
                    max-width: 670px;
                    font-size: 24px;
                    line-height: 1.65;
                    margin-top: 30px;
                  }
                }
              }

              li:nth-child(2n) {
                display: flex;
                flex-direction: row-reverse;
                padding-left: 0;

                img {
                  height: 300px;
                  margin-left: -0px;
                }

                div {
                  margin-top: 0.3%;
                  margin-left: -5%;

                  h4 {
                    font-size: 33px;
                    font-weight: bolder;
                    color: #217a73;
                    font-weight: 400;
                    font-family: "HelveticaNeueCyr";
                    font-weight: 400;
                  }

                  p {
                    color: #8a8a8a;
                    max-width: 680px;
                    font-size: 24px;
                    line-height: 1.66;
                    margin-left: 0px;
                    margin-top: 28px;
                  }
                }
              }

              li:nth-child(3) {
                display: flex;
                position: relative;
                justify-content: space-around;
                margin: 150px 0px;
                padding-left: 93px;
                margin-bottom: 107px;
                margin-top: -37px;

                div {
                  margin-top: 5.5%;
                  margin-left: 8%;

                  h4 {
                    font-size: 33.5px;
                    color: #217a73;
                    font-family: "HelveticaNeueCyr";
                    font-weight: 400;
                    margin-left: -3px;
                  }

                  p {
                    color: #8a8a8a;
                    max-width: 685px;
                    font-size: 24px;
                    line-height: 1.65;
                    margin-top: 30px;
                  }
                }
              }

              li:nth-child(1):after {
                content: "";
                background-image: url("../assets/images/Group 1580.png");
                position: absolute;
                background-size: contain;
                background-repeat: no-repeat;
                top: -34%;
                left: 44%;
                width: 285px;
                height: 285px;
              }

              li:nth-child(2):after {
                content: "";
                background-image: url("../assets/images/Group 1582.png");
                position: absolute;
                background-size: contain;
                background-repeat: no-repeat;
                top: -119%;
                margin-left: -5px;
                width: 1200px;
                height: 400px;
              }

              li:nth-child(3):after {
                content: "";
                background-image: url("../assets/images/Group 1583.png");
                position: absolute;
                background-size: contain;
                background-repeat: no-repeat;
                top: -55%;
                right: 10%;
                width: 500px;
                height: 250px;
              }

              li:nth-child(3):before {
                content: "";
                background-image: url("../assets/images/Group 1584.png");
                position: absolute;
                background-size: contain;
                background-repeat: no-repeat;
                top: 90%;
                right: -1.2%;
                width: 590px;
                height: 150px;
              }
            }

            a {
              display: inline-block;
              color: #fff;
              font-size: 16px;
              background-color: #49d6cb;
              padding: 14.5px 52.2px;
              border-radius: 5px;
              margin-left: 44.63%;
              border: 1px solid transparent;
              transition: all 0.5s;
            }

            a:hover {
              color: #49d6cb;
              border: 1px solid #49d6cb;
              background-color: #fff;
            }
          }
        }
    }
    .texnologySection {
    .texnologyWrapper {
      .texnologyBody {
        margin-top: 75px;

        h3 {
          font-size: 39px;
          color: #217a73;
          text-align: center;
          position: relative;
          font-family: 'HelveticaNeueCyr';
          font-weight: bold;
          letter-spacing: -0.1px;
          margin-left: -55px;
        }

        p {
          color: #7d7d7d;
          font-size: 23.8px;
          max-width: 1410px;
          margin: 0 auto;
          padding: 52px 0px;
          padding-left: 30px;
          line-height: 40px;
        }

        h3:before {
          content: "";
          background-image: url("../assets/images/servis_bacground.png");
          position: absolute;
          background-size: contain;
          background-repeat: no-repeat;
          width: 280px;
          left: 10.5%;
          top: 30px;
          height: 280px;
          z-index: -2;
        }

        ul {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          padding-left: 0px;
          margin-top: -10px;
          margin-bottom: 7px;
          li {
            width: 110px;
            height: 120px;
            margin: 12px 14.5px;
            border-radius: 5px;
            background-color: #fff;
            border: 1px solid transparent;
            position: relative;
            img {
                display: block;
                margin: 0 auto; 
                margin-top: 13px;             
            }

            p {
              font-size: 14px;
              color: #fff;
              text-align: center;
              position: absolute;
              bottom: -50px;
              left: -5px;
            }

            transition: all 0.5s;
          }

          li:hover {
            box-shadow: 0px 0px 15px 5px rgba(0, 0, 0, 0.1607843137254902);
            border: 1px solid rgba(0, 0, 0, 0.1607843137254902);
            cursor: pointer;
            p {
              color: #000;
            }
          }
        }
      }
    }
    }
  }

  @media only screen and (max-width: 1310px) {
    .container {
      width: 1200px;
    }
     .servicessection {
      background-color: #f4f6fc;
      margin-top: -225px;

      .serviceswrapper {
        .servicesbody {
          text-align: center;
          padding-top: 80px;

          h3 {
            font-size: 40px;
            color: #217a73;
            font-weight: 400;
          }

          p {
            color: #7d7d7d;
            max-width: 950px;
            line-height: 1.5;
            margin: 0 auto;
            font-size: 24px;
            padding-top: 20px;
          }


          ul::before {
            content: "";
            background-image: url("../assets/images/servis_bacground.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            bottom: -15%;
            right: 4%;
            width: 270px;
            height: 270px;
          }

          div {
            img {
              margin-bottom: -50px;
            }
          }
        }
      }
    }
    .heroSection {
      background-image: url("../assets/images/img_bacground_4.png"), url("../assets/images/img_bacground_1.png");
      background-size: 450px, 900px;
      background-repeat: no-repeat;
      background-position: top left, top right;
      margin-top: -90px;

      .heroWrapper {
        padding-top: 60px;
        padding-bottom: 180px;

        .heroBody {
          margin-top: 180px;
          display: flex;
          justify-content: space-between;

          div {
            h1 {
              margin-top: 10%;
              font-size: 50px;
              line-height: 55px;
              max-width: 400px;
              position: relative;
            }

            h1::before {
              content: "";
              background-image: url("../assets/images/dots_hero.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              left: -10%;
              top: 35%;
              width: 120px;
              height: 120px;
            }

            h1::after {
              content: "";
              background-image: url("../assets/images/bacground_hero_2.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              width: 200px;
              height: 200px;
              top: -55%;
              left: 35%;
              z-index: -1;
            }

            p {
              margin-top: 10px;
              max-width: 600px;
              font-size: 20px;
            }
          }

          div {
            img:nth-child(1) {
              width: 450px;
            }

            img:nth-child(2) {
              position: fixed;
              bottom: 2%;
              right: 3%;
              z-index: 50000;
              animation: animateCallImg 7s;
              animation-iteration-count: infinite;
            }
          }

        }
      }
    }
    .workLineSection {
      .workLineWrapper {
        .workLineBody {
          margin-top: 100px;

          h3 {
            text-align: center;
            font-size: 40px;
            color: #217a73;
            font-weight: 400;
          }

          ul {
            li {
              display: flex;
              position: relative;
              justify-content: space-around;
              margin: 150px 0;

              div {
                margin-top: 5%;

                h4 {
                  font-size: 32px;
                  color: #217a73;
                  font-weight: 400;
                }

                p {
                  color: #8a8a8a;
                  max-width: 640px;
                  font-size: 24px;
                  line-height: 1.4;
                  margin-top: 20px;
                }
              }
            }

            li:nth-child(2n) {
              display: flex;
              flex-direction: row-reverse;
            }

            li:nth-child(1):after {
              content: "";
              background-image: url("../assets/images/Group 1580.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: -30%;
              width: 270px;
              height: 270px;
            }

            li:nth-child(2):after {
              content: "";
              background-image: url("../assets/images/Group 1582.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: -100%;
              width: 1050px;
              height: 400px;
            }

            li:nth-child(3):after {
              content: "";
              background-image: url("../assets/images/Group 1583.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: -33%;
              right: 13%;
              width: 450px;
              height: 200px;
            }

            li:nth-child(3):before {
              content: "";
              background-image: url("../assets/images/Group 1584.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: 91%;
              right: 0%;
              width: 550px;
              height: 130px;
            }
          }

          a {
            color: #fff;
            font-size: 16px;
            background-color: #49d6cb;
            padding: 15px 50px;
            border-radius: 10px;
            margin-left: 45%;
          }
        }
      }
    }
     .pixyzEasysection {
      background-image: url("../assets/images/img_bacground_3.png"), url("../assets/images/img_bacground_2.png");
      background-size: 900px, 900px;
      background-repeat: no-repeat;
      background-position: top left, top right;
      padding: 110px;

    .pixyzEasywrapper {
      .pixyzEasybody {
        text-align: center;
        padding-top: 30px;

        h1 {
          font-size: 40px;
          color: #217a73;
          font-family: "HelveticaNeueCyr";
          font-weight: bold;
          font-style: normal;
          padding-bottom: 22px;
          margin-left: -33px;
          margin-top: 8.5px;
          letter-spacing: -0.3px;
        }

        p {
          font-size: 24px;
          color: #8a8a8a;
          max-width: 1360px;
          font-family: "HelveticaNeueCyr";
          margin: 0 auto;
          text-align: left;
          line-height: 40px;
          padding-bottom: 260px;
          padding-left: 6px;
          margin-top: 5px;
          position: relative;
        }

        p::before {
          content: "";
          background-image: url("../assets/images/Component 2 – 1.png");
          position: absolute;
          background-size: contain;
          background-repeat: no-repeat;
          top: 51%;
          left: 38%;
          width: 300px;
          height: 300px;
        }
      }
    }
    }
  }

  @media only screen and (max-width: 1250px) {
    .container {
      width: 1100px;
    }

    .heroSection {
      background-image: url("../assets/images/img_bacground_4.png"), url("../assets/images/img_bacground_1.png");
      background-size: 450px, 900px;
      background-repeat: no-repeat;
      background-position: top left, top right;
      margin-top: -95px;

      .heroWrapper {
        padding-top: 60px;
        padding-bottom: 180px;

        .heroBody {
          margin-top: 180px;
          display: flex;
          justify-content: space-between;

          div {
            h1 {
              margin-top: 10%;
              font-size: 50px;
              line-height: 55px;
              max-width: 400px;
              position: relative;
            }

            h1::before {
              content: "";
              background-image: url("../assets/images/dots_hero.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              left: -10%;
              top: 35%;
              width: 120px;
              height: 120px;
            }

            h1::after {
              content: "";
              background-image: url("../assets/images/bacground_hero_2.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              width: 200px;
              height: 200px;
              top: -55%;
              left: 35%;
              z-index: -1;
            }

            p {
              margin-top: 10px;
              max-width: 600px;
              font-size: 20px;
            }
          }

          div {
            img:nth-child(1) {
              width: 450px;
            }

            img:nth-child(2) {
              position: fixed;
              bottom: 2%;
              right: 3%;
              z-index: 50000;
              animation: animateCallImg 7s;
              animation-iteration-count: infinite;
            }
          }

        }
      }
    }

    .pixyzEasysection {
      background-image: url("../assets/images/img_bacground_3.png"), url("../assets/images/img_bacground_2.png");
      background-size: 900px, 900px;
      background-repeat: no-repeat;
      background-position: top left, top right;
      padding: 100px;

      .pixyzEasywrapper {
        .pixyzEasybody {
          text-align: center;
          padding-top: 80px;

          h1 {
            font-size: 35px;
            color: #217a73;
            padding-bottom: 20px;
          }

          p {
            font-size: 20px;
            color: #8a8a8a;
            max-width: 1200px;
            margin: 0 auto;
            line-height: 1.5;
            padding-bottom: 260px;
            position: relative;
          }

          p::before {
            content: "";
            background-image: url("../assets/images/Component 2 – 1.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            top: 44%;
            left: 36%;
            width: 350px;
            height: 350px;
          }
        }
      }
    }

    .servicessection {
      background-color: #f4f6fc;
      margin-top: -160px;

      .serviceswrapper {
        .servicesbody {
          text-align: center;
          padding-top: 80px;

          h3 {
            font-size: 40px;
            color: #217a73;
            font-weight: 400;
          }

          p {
            color: #7d7d7d;
            max-width: 950px;
            line-height: 1.5;
            margin: 0 auto;
            font-size: 24px;
            padding-top: 20px;
          }
          ul::before {
            content: "";
            background-image: url("../assets/images/servis_bacground.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            bottom: -15%;
            right: 4%;
            width: 270px;
            height: 270px;
          }
          div {
            img {
              margin-bottom: -40px;
            }
          }
        }
      }
    }

    .postUserSection {
      .postUserWrapper {
        .postUserBody {
          max-width: 1380px;
          margin: 0 auto;
          -webkit-box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.160784);
          box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.160784);
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          margin-top: 88px;

          .post_user_left {
            width: 500px;
            padding: 20px;
            h3 {
              color: #217a73;
              font-size: 30px;
              margin-top: 25px;
              margin-left: 60px;
            }

            form {
              display: -webkit-box;
              display: -ms-flexbox;
              display: flex;
              -ms-flex-wrap: wrap;
              flex-wrap: wrap;
              margin-left: 25px;
              margin-top: 20px;
              width: 500px;

              input {
                margin: 5px 5px;
                padding: 13px;
                padding-left: 5px;
                width: 200px;
                border: none;
                border: 1px solid #49d6cb !important;
                color: #c9c9c9 !important;
                font-size: 10px;
              }

              select {
                padding: 13px;
                width: 200px;
                color: #c9c9c9;
                margin: 5px 5px;
                padding-left: 5px;
                border: none;
                border: 1px solid #49d6cb;
                background-color: inherit !important;
                position: relative;
                overflow: hidden;
                overflow: -moz-hidden-unscrollable;
                background: url("@/assets/images/selectDownImg.png") no-repeat right;
                background-position: top 16px right 10px;
                background-size: 15px;
                display: inline-block;
                position: relative;
                font-size: 8px;
            }

              textarea {
                width: 410px;
                margin: 5px;
                padding: 13px 13px;
                height: 150px;
                text-align: left;
                border: none;
                color: #c9c9c9;
                border: 1px solid #49d6cb;
                background-color: inherit !important;
                resize: none;
                font-size: 10px;
              }

              button {
                background-color: #49d6cb;
                display: block;
                border: 1px solid #fff;
                padding: 15.5px 59px;
                color: #fff;
                margin: 19.1px 15px;
                -webkit-transition: all 0.5s;
                transition: all 0.5s;
                font-size: 12px;

              }

              button:hover {
                background-color: #fff;
                color: #49d6cb;
                border: 1px solid #49d6cb;
              }
            }
          }

          .post_user_right {
            background-image: url("../assets/images/img_post.png");
            background-position: bottom 10px right 20px;
            background-repeat: no-repeat;
            background-size: 220px;
            background-color: #49d6cb;
            width: 400px;
            padding-left: 25px;
            padding-top: 40px;
            h3 {
              color: #fff;
              font-size: 32px;
              font-weight: 500;
              margin-top: 20px;
            }

            a {
              display: block;
              color: #fff;
              font-size: 16px;
              font-weight: normal;
              margin-top: 30px;
              padding-bottom: 15px;
            }
          }

        }
      }
    }

    .workLineSection {
      .workLineWrapper {
        .workLineBody {
          margin-top: 100px;

          h3 {
            text-align: center;
            font-size: 40px;
            color: #217a73;
            font-weight: 400;
          }

          ul {
            li {
              display: flex;
              position: relative;
              justify-content: space-between;
              margin: 100px 0;

              img {
                width: 300px;
              }

              div {
                margin: auto 0;
                margin-left: 4%;
                h4 {
                  font-size: 22px;
                  color: #217a73;
                  font-weight: 400;
                }

                p {
                  color: #8a8a8a;
                  max-width: 600px;
                  font-size: 16px;
                  line-height: 1.4;
                  margin-top: 20px;
                }
              }
            }

            li:nth-child(2n) {
              display: flex;
              flex-direction: row-reverse;
              img {
                height: 250px;
              }
              div {
                margin-top: 5%;

                h4 {
                  font-size: 22px;
                  color: #217a73;
                  font-weight: 400;
                }

                p {
                  color: #8a8a8a;
                  max-width: 500px;
                  font-size: 16px;
                  line-height: 1.4;
                  margin-top: 20px;
                }
              }
            }
            li:nth-child(3) {
                display: flex;
                position: relative;
                justify-content: space-around;
                margin: 150px 0px;
                padding-left: 93px;
                margin-bottom: 107px;
                margin-top: 0px;

                div {
                  margin-top: 5.5%;
                  margin-left: 8%;

                  h4 {
                    font-size: 28px;
                    color: #217a73;
                    font-family: "HelveticaNeueCyr";
                    font-weight: 400;
                    margin-left: -3px;
                  }

                  p {
                    color: #8a8a8a;
                    max-width: 685px;
                    font-size: 18px;
                    line-height: 1.65;
                    margin-top: 30px;
                  }
                }
              }
            li:nth-child(1):after {
              content: "";
              background-image: url("../assets/images/Group 1580.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: -30%;
              left: 40%;
              width: 200px;
              height: 200px;
            }

            li:nth-child(2):after {
              content: "";
              background-image: url("../assets/images/Group 1582.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: -85%;
              width: 800px;
              height: 400px;
            }

            li:nth-child(3):after {
              content: "";
              background-image: url("../assets/images/Group 1583.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: -25%;
              right: 15%;
              width: 250px;
              height: 250px;
            }

            li:nth-child(3):before {
              content: "";
              background-image: url("../assets/images/Group 1584.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: 92%;
              right: 0%;
              width: 500px;
              height: 130px;
            }
          }

          a {
            color: #fff;
            font-size: 16px;
            background-color: #49d6cb;
            padding: 15px 50px;
            border-radius: 10px;
            margin-left: 35%;
          }
        }
      }
    }
  }

  @media only screen and (max-width: 1010px) {
    .container {
      width: 900px;
    }
    .heroSection {
      background-image: url("../assets/images/img_bacground_4.png"), url("../assets/images/img_bacground_1.png");
      background-size: 300px, 700px;
      background-repeat: no-repeat;
      background-position: top left, top right;
      margin-top: -90px;

      .heroWrapper {
        padding-top: 60px;
        padding-bottom: 80px;

        .heroBody {
          margin-top: 120px;
          display: flex;
          justify-content: space-between;

          div {
            h1 {
              margin-top: 10%;
              font-size: 40px;
              line-height: 55px;
              max-width: 400px;
              position: relative;
            }

            h1::before {
              content: "";
              background-image: url("../assets/images/dots_hero.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              left: -10%;
              top: 35%;
              width: 120px;
              height: 120px;
            }

            h1::after {
              content: "";
              background-image: url("../assets/images/bacground_hero_2.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              width: 200px;
              height: 200px;
              top: -55%;
              left: 35%;
              z-index: -1;
            }

            p {
              margin-top: 10px;
              max-width: 600px;
              font-size: 20px;
            }
          }

          div {
            img:nth-child(1) {
              width: 450px;
            }

            img:nth-child(2) {
              position: fixed;
              bottom: 2%;
              right: 3%;
              z-index: 50000;
              animation: animateCallImg 7s;
              animation-iteration-count: infinite;
            }
          }

        }
      }
    }
    .pixyzEasysection {
      background-image: url("../assets/images/img_bacground_3.png"), url("../assets/images/img_bacground_2.png");
      background-size: 700px, 700px;
      background-repeat: no-repeat;
      background-position: top left, top right;
      padding: 0px;

      .pixyzEasywrapper {
        .pixyzEasybody {
          text-align: center;
          padding-top: 80px;

          h1 {
            font-size: 30px;
            color: #217a73;
            padding-bottom: 20px;
          }

          p {
            font-size: 16px;
            color: #8a8a8a;
            max-width: 800px;
            margin: 0 auto;
            line-height: 1.5;
            padding-bottom: 260px;
            position: relative;
          }

          p::before {
            content: "";
            background-image: url("../assets/images/Component 2 – 1.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            top: 35%;
            left: 35%;
            width: 350px;
            height: 350px;
          }
        }
      }
    }

    .servicessection {
      background-color: #f4f6fc;
      margin-top: -65px;

      .serviceswrapper {
        .servicesbody {
          text-align: center;
          padding-top: 50px;

          h3 {
            font-size: 36px;
            color: #217a73;
            font-weight: 400;
          }

          p {
            color: #7d7d7d;
            max-width: 950px;
            line-height: 1.5;
            margin: 0 auto;
            font-size: 18px;
            padding-top: 20px;
          }



          ul::before {
            content: "";
            background-image: url("../assets/images/servis_bacground.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            bottom: -10%;
            right: 8%;
            width: 200px;
            height: 200px;
          }

          div {
            img {
              margin-bottom: -50px;
            }
          }
        }
      }
    }

    .postUserSection {
      .postUserWrapper {
        .postUserBody {
          margin: 0 auto;
          -webkit-box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.160784);
          box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.160784);
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          margin-top: 80px;

          .post_user_left {
            width: 70%;
            padding: 20px;

            h3 {
              color: #217a73;
              font-size: 32px;
              margin-left: 30px;
            }

            form {
              display: -webkit-box;
              display: -ms-flexbox;
              display: flex;
              -ms-flex-wrap: wrap;
              flex-wrap: wrap;

              input {
                margin: 5px;
                padding: 10px;
                width: 200px;
                border: none;
                border: 1px solid #49d6cb !important;
                color: #c9c9c9 !important;
              }
               select {
                padding: 10px;
                width: 200px;
                color: #c9c9c9;
                margin: 5px;
                border: none;
                border: 1px solid #49d6cb;
                background-color: inherit !important;
                position: relative;
                overflow: hidden;
                overflow: -moz-hidden-unscrollable;
                background: url("@/assets/images/selectDownImg.png") no-repeat right;
                background-position: top 14px right 10px;
                background-size: 14px;
                display: inline-block;
                position: relative;
                font-size: 8px;
              }

              textarea {
                width: 420px;
                margin: 5px;
                padding: 10px;
                text-align: left;
                border: none;
                color: #c9c9c9;
                border: 1px solid #49d6cb;
                background-color: inherit !important;
                resize: none;
              }

              button {
                background-color: #49d6cb;
                display: block;
                border: 1px solid #fff;
                padding: 15px 50px;
                color: #fff;
                margin: 10px;
                -webkit-transition: all 0.5s;
                transition: all 0.5s;
              }

              button:hover {
                background-color: #fff;
                color: #49d6cb;
                border: 1px solid #49d6cb;
              }
            }
          }

          .post_user_right {
            background-image: url("../assets/images/img_post.png");
            background-position: bottom right;
            background-repeat: no-repeat;
            background-size: 220px;
            background-color: #49d6cb;
            width: 350px;
            padding-left: 30px;

            h3 {
              color: #fff;
              font-size: 32px;
              font-weight: 600;
              margin-top: 45px;
              margin-top: 0;
            }

            a {
              display: block;
              color: #fff;
              font-size: 12px;
              font-weight: normal;
              margin-top: 30px;
            }
          }

        }
      }
    }

    .workLineSection {
      .workLineWrapper {
        .workLineBody {
          margin-top: 100px;

          h3 {
            text-align: center;
            font-size: 40px;
            color: #217a73;
            font-weight: 400;
          }

          ul {
            li {
              display: flex;
              position: relative;
              justify-content: space-between;
              margin: 100px 0;
              padding: 0 40px;

              img {
                width: 250px;
              }

              div {
                margin-top: 5%;

                h4 {
                  font-size: 28px;
                  color: #217a73;
                  font-weight: 400;
                }

                p {
                  color: #8a8a8a;
                  max-width: 500px;
                  font-size: 20px;
                  line-height: 1.4;
                  margin-top: 20px;
                }
              }
            }

            li:nth-child(2n) {
              display: flex;
              flex-direction: row-reverse;
              justify-content: space-between;
              margin: 100px 0;
              padding: 0 40px;

              img {
                width: auto;
                height: 200px;
                margin: auto 0;
              }
              div {
                margin-top: 5%;

                h4 {
                  font-size: 24px;
                  color: #217a73;
                  font-weight: 400;
                }

                p {
                  color: #8a8a8a;
                  max-width: 400px;
                  font-size: 15px;
                  line-height: 1.4;
                  margin-top: 20px;
                }
              }
            }

            li:nth-child(1):after {
              content: "";
              background-image: url("../assets/images/Group 1580.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: -30%;
              left: 40%;
              width: 200px;
              height: 200px;
            }

            li:nth-child(2):after {
              content: "";
              background-image: url("../assets/images/Group 1582.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: -80%;
              right: 5%;
              width: 750px;
              height: 400px;
            }

            li:nth-child(3):after {
              content: "";
              background-image: url("../assets/images/Group 1583.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: -30%;
              right: 15%;
              width: 300px;
              height: 300px;
            }

            li:nth-child(3):before {
              content: "";
              background-image: url("../assets/images/Group 1584.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: 96%;
              right: 4%;
              width: 450px;
              height: 120px;
              z-index: -5;
            }
          }

          a {
            color: #fff;
            font-size: 16px;
            background-color: #49d6cb;
            padding: 15px 50px;
            border-radius: 10px;
            margin-left: 35%;
          }
        }
      }
    }
  }

  @media only screen and (max-width: 850px) {
    .container {
      width: 600px;
    }

    .heroSection {
      background-image: url("../assets/images/img_bacground_4.png"), url("../assets/images/img_bacground_1.png");
      background-size: 250px, 600px;
      background-repeat: no-repeat;
      background-position: top left, top right;
      margin-top: -80px;

      .heroWrapper {
        padding-top: 60px;
        padding-bottom: 80px;

        .heroBody {
          margin-top: 100px;
          display: flex;
          justify-content: space-between;

          div {
            margin-left: 40px;

            h1 {
              margin-top: 10%;
              font-size: 25px;
              line-height: 30px;
              max-width: 200px;
              position: relative;
            }

            h1::before {
              content: "";
              background-image: url("../assets/images/dots_hero.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              left: -15%;
              top: 35%;
              width: 100px;
              height: 100px;
            }

            h1::after {
              content: "";
              background-image: url("../assets/images/bacground_hero_2.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              width: 100px;
              height: 100px;
              top: -60%;
              left: 35%;
              z-index: -1;
            }

            p {
              margin-top: 10px;
              max-width: 250px;
              font-size: 12px;
              line-height: 20px;
            }
          }

          div {
            img:nth-child(1) {
              width: 350px;
            }

            img:nth-child(2) {
              position: fixed;
              bottom: 2%;
              right: 3%;
              z-index: 50000;
              animation: animateCallImg 7s;
              animation-iteration-count: infinite;
            }
          }

        }
      }
    }

    .pixyzEasysection {
      background-image: url("../assets/images/img_bacground_3.png"), url("../assets/images/img_bacground_2.png");
      background-size: 600px, 600px;
      background-repeat: no-repeat;
      background-position: top left, top right;
      padding: 0px;

      .pixyzEasywrapper {
        .pixyzEasybody {
          text-align: center;
          padding-top: 80px;

          h1 {
            font-size: 25px;
            color: #217a73;
            padding-bottom: 20px;
          }

          p {
            font-size: 14px;
            color: #8a8a8a;
            max-width: 90%;
            margin: 0 auto;
            line-height: 1.5;
            padding-bottom: 220px;
            position: relative;
          }

          p::before {
            content: "";
            background-image: url("../assets/images/Component 2 – 1.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            top: 30%;
            left: 40%;
            width: 300px;
            height: 300px;
          }
        }
      }
    }

    .servicessection {
      background-color: #f4f6fc;
      margin-top: -75px;

      .serviceswrapper {
        .servicesbody {
          text-align: center;
          padding-top: 50px;

          h3 {
            font-size: 36px;
            color: #217a73;
            font-weight: 400;
          }

          p {
            color: #7d7d7d;
            max-width: 950px;
            line-height: 1.5;
            margin: 0 auto;
            font-size: 18px;
            padding-top: 20px;
          }



          ul::before {
            content: "";
            background-image: url("../assets/images/servis_bacground.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            bottom: -10%;
            right: 8%;
            width: 200px;
            height: 200px;
          }

          div {
            img {
              margin-bottom: -50px;
            }
          }
        }
      }
    }

    .postUserSection {
      .postUserWrapper {
        .postUserBody {
          margin: 0 auto;
          -webkit-box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.160784);
          box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.160784);
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          margin-top: 80px;

          .post_user_left {
            width: 100%;
            padding: 20px;

            h3 {
              color: #217a73;
              font-size: 28px;
              padding: 10px 0;
            }

            form {
              display: -webkit-box;
              display: -ms-flexbox;
              display: flex;
              -ms-flex-wrap: wrap;
              justify-content: center;
              flex-wrap: wrap;
              width: 100%;
              input {
                margin: 10px;
                padding: 15px;
                width: 300px;
                border: none;
                border: 1px solid #49d6cb !important;
                color: #c9c9c9 !important;
              }

              select {
                padding: 15px;
                width: 300px;
                color: #c9c9c9;
                margin: 10px;
                border: none;
                border: 1px solid #49d6cb;
                background-color: inherit !important;
                position: relative;
                overflow: hidden;
                overflow: -moz-hidden-unscrollable;
                background: url("@/assets/images/selectDownImg.png") no-repeat right;
                background-position: top 16px right 15px;
                background-size: 25px;
                display: inline-block;
                position: relative;
                font-size: 8px;
              }

              textarea {
                width: 620px;
                margin: 10px;
                padding: 15px;
                text-align: left;
                border: none;
                color: #c9c9c9;
                border: 1px solid #49d6cb;
                background-color: inherit !important;
                resize: none;
              }

              button {
                background-color: #49d6cb;
                display: block;
                border: 1px solid #fff;
                padding: 15px 50px;
                color: #fff;
                margin: 10px;
                -webkit-transition: all 0.5s;
                transition: all 0.5s;
              }

              button:hover {
                background-color: #fff;
                color: #49d6cb;
                border: 1px solid #49d6cb;
              }
            }
          }

          .post_user_right {
            display: none;
            background-image: url("../assets/images/img_post.png");
            background-position: bottom right;
            background-repeat: no-repeat;
            background-size: 200px;
            background-color: #49d6cb;
            width: 420px;
            padding-left: 30px;

            h3 {
              color: #fff;
              font-size: 32px;
              font-weight: 600;
              margin-top: 45px;
            }

            a {
              display: block;
              color: #fff;
              font-size: 16px;
              font-weight: normal;
              margin-top: 45px;
            }
          }

        }
      }
    }

    .workLineSection {
      .workLineWrapper {
        .workLineBody {
          margin-top: 100px;

          h3 {
            text-align: center;
            font-size: 40px;
            color: #217a73;
            font-weight: 400;
          }

          ul {
            margin: 0!important;
            padding: 0!important;
            li {
              display: flex;
              position: relative;
              flex-direction: column;
              justify-content: center;
              margin: 100px 0;
              text-align: center;
              padding: 0!important;
              img {
                height: auto;
                margin: 0 auto;
                width: 340px!important;
              }

              div {
                margin: 0 auto;
                margin-top: 3%;
                h4 {
                  font-size: 28px;
                  color: #217a73;
                  font-weight: 400;
                }

                p {
                  color: #8a8a8a;
                  max-width: 500px;
                  font-size: 20px;
                  line-height: 1.4;
                  margin-top: 20px;
                  margin: 0 auto;

                }
              }
            }

            li:nth-child(2n) {
              display: flex;
              flex-direction: column;
              margin: 0 auto;
              justify-content: center;
              text-align: center;
              img {
                margin: 0 auto;
                width: 340px!important;
              }
              div {
                margin: 0 auto;
                margin-top: 3%;
                
              }
            }
            li:nth-child(3) {
              margin-top: 50px;
              img {
                margin: 0 auto;
                width: 340px!important;
              }
                div {
                  margin: 0 auto;
                  margin-top: 20px;
                }
            }
            li:nth-child(1):after {
              display: none;
              content: "";
              background-image: url("../assets/images/Group 1580.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: -30%;
              left: 40%;
              width: 200px;
              height: 200px;
            }

            li:nth-child(2):after {
              display: none;
              content: "";
              background-image: url("../assets/images/Group 1582.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: -80%;
              right: 5%;
              width: 750px;
              height: 400px;
            }

            li:nth-child(3):after {
              display: none;
              content: "";
              background-image: url("../assets/images/Group 1583.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: -30%;
              right: 15%;
              width: 300px;
              height: 300px;
            }

            li:nth-child(3):before {
              display: none;
              content: "";
              background-image: url("../assets/images/Group 1584.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: 80%;
              right: 7%;
              width: 450px;
              height: 400px;
            }
          }

          a {
            color: #fff;
            font-size: 16px;
            background-color: #49d6cb;
            padding: 15px 50px;
            border-radius: 10px;
            margin-left: 35%;
          }
        }
      }
    }

    .texnologySection {
      .texnologyWrapper {
        .texnologyBody {
          margin-top: 50px;

          h3 {
            font-size: 30px;
            color: #217a73;
            text-align: center;
            font-weight: 500;
            position: relative;

          }

          p {
            color: #7d7d7d;
            font-size: 16px;
            max-width: 1400px;
            margin: 0 auto;
            padding: 20px 0;
          }

          h3:before {
            display: none;
            content: "";
            background-image: url("../assets/images/servis_bacground.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            width: 200px;
            left: 0;
            top: 20px;
            height: 200px;
            z-index: -2;
          }

          ul {
            display: flex;
            flex-wrap: wrap;

            li {
              width: 70px;
              height: 80px;
              margin: 5px;
              border-radius: 5px;
              background-color: #fff;

              img {
                margin-left: 25%;
                margin-top: 10px;
                width: 30px;
              }

              p {
                font-size: 10px;
                color: #fff;
                margin-top: -10px;
                text-align: center;
              }
            }

            li:hover {
              box-shadow: 0px 0px 15px 5px rgba(0, 0, 0, 0.1607843137254902);

              p {
                color: #000;
              }
            }
          }
        }
      }
    }

    .sliderSection {
      background-color: #f4f6fc;
    }
  }

  @media only screen and (max-width: 650px) {
    .container {
      width: 600px;
    }

    .heroSection {
    background-image: url("../assets/images/img_bacground_4.png"), url("../assets/images/img_bacground_1.png");
    background-size: 570px, 1030px;
    background-image: none;
    background-repeat: no-repeat;
    background-position: top left, top right;
    margin-top: -90px;

    .heroWrapper {
      padding-top: 0px;
      padding-bottom: 54px;

      .heroBody {
        margin-top: 195px;
        display: flex;
        padding: 0 10px;
        justify-content: space-between;

        div {
          h1 {
            margin-top: 9.5%;
            font-size: 22px;
            line-height: 30px;
            font-family: "HelveticaNeueCyr";
            font-weight: 600;
            max-width: 400px;
            position: relative;
            margin-left: 10px;
          }

          h1::before {
            content: "";
            background-image: url("../assets/images/dots_hero.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            left: -16.5%;
            top: 30%;
            width: 90px;
            height: 77px;
          }

          h1::after {
            content: "";
            background-image: url("../assets/images/bacground_hero_2.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            width: 100px;
            height: 100px;
            top: -50%;
            left: 40%;
            z-index: -1;
          }

          p {
            margin-top: 12px;
            max-width: 750px;
            font-size: 14px;
            margin-left: 10px;
            line-height: 18px;
          }
        }

        div {
          img:nth-child(2) {
            position: fixed;
            bottom: 10.4%;
            right: 5.35%;
            width: 48px;
            height: 48px;
            z-index: 5000;
            animation: animateCallImg 7s;
            animation-iteration-count: infinite;
          }
          img:nth-child(1) {
            width: 220px;
            margin-top: 10px;
          }
        }

      }
    }
    }

    .pixyzEasysection {
      background-image: url("../assets/images/img_bacground_3.png"), url("../assets/images/img_bacground_2.png");
      background-size: 600px, 600px;
      background-image: none;
      background-repeat: no-repeat;
      background-position: top left, top right;
      padding: 0px;

      .pixyzEasywrapper {
        .pixyzEasybody {
          text-align: center;
          padding-top: 80px;
          h1 {
            font-size: 20px;
            color: #217a73;
            padding-bottom: 20px;
          }

          p {
            font-size: 14px;
            color: #8a8a8a;
            max-width: 90%;
            margin: 0 auto;
            line-height: 1.5;
            padding-bottom: 220px;
            position: relative;
            text-align: center;
          }

          p::before {
            content: "";
            background-image: url("../assets/images/Component 2 – 1.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            top: 45%;
            left: 35%;
            width: 250px;
            height: 250px;
          }
          
        }
      }
    }

    .servicessection {
      background-color: #f4f6fc;
      margin-top: -65px;

      .serviceswrapper {
        .servicesbody {
          text-align: center;
          padding-top: 50px;

          h3 {
            font-size: 30px;
            color: #217a73;
            font-weight: 400;
          }

          p {
            color: #7d7d7d;
            max-width: 90%;
            line-height: 1.5;
            margin: 0 auto;
            font-size: 14px;
            padding-top: 20px;
          }



          ul::before {
            content: "";
            background-image: url("../assets/images/servis_bacground.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            bottom: -5%;
            right: 8%;
            width: 150px;
            height: 150px;
          }

          div {
            img {
              margin-bottom: -50px;
            }
          }
        }
      }
    }

    .postUserSection {
      .postUserWrapper {
        .postUserBody {
          margin: 0 auto;
          -webkit-box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.160784);
          box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.160784);
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          margin-top: 80px;

          .post_user_left {
            width: 100%;
            padding: 20px;

            h3 {
              color: #217a73;
              font-size: 28px;
              padding: 10px 0;
            }

            form {
              display: -webkit-box;
              display: -ms-flexbox;
              display: flex;
              -ms-flex-wrap: wrap;
              justify-content: center;
              flex-wrap: wrap;
              width: 100%;
              margin: 0;
              input {
                margin: 10px;
                padding: 15px;
                width: 230px;
                border: none;
                border: 1px solid #49d6cb !important;
                color: #c9c9c9 !important;
              }

              select {
                padding: 15px;
                width: 230px;
                color: #c9c9c9;
                margin: 10px;
                border: none;
                border: 1px solid #49d6cb;
                background-color: inherit !important;
              }

              textarea {
                width: 480px;
                margin: 10px;
                padding: 15px;
                text-align: left;
                border: none;
                color: #c9c9c9;
                border: 1px solid #49d6cb;
                background-color: inherit !important;
                resize: none;
              }

              button {
                background-color: #49d6cb;
                display: block;
                border: 1px solid #fff;
                padding: 15px 50px;
                color: #fff;
                margin: 10px;
                -webkit-transition: all 0.5s;
                transition: all 0.5s;
              }

              button:hover {
                background-color: #fff;
                color: #49d6cb;
                border: 1px solid #49d6cb;
              }
            }
          }

          .post_user_right {
            display: none;
            background-image: url("../assets/images/img_post.png");
            background-position: bottom right;
            background-repeat: no-repeat;
            background-size: 200px;
            background-color: #49d6cb;
            width: 420px;
            padding-left: 30px;

            h3 {
              color: #fff;
              font-size: 32px;
              font-weight: 600;
              margin-top: 45px;
            }

            a {
              display: block;
              color: #fff;
              font-size: 16px;
              font-weight: normal;
              margin-top: 45px;
            }
          }

        }
      }
    }

    .workLineSection {
      .workLineWrapper {
        .workLineBody {
          margin-top: 100px;

          h3 {
            text-align: center;
            font-size: 40px;
            color: #217a73;
            font-weight: 400;
          }

          ul {
            margin: 0!important;
            padding: 0!important;
            li {
              display: flex;
              position: relative;
              flex-direction: column;
              justify-content: center;
              margin: 100px 0;
              text-align: center;
              padding: 0!important;
              img {
                width: 60%!important;
                height: auto;
                margin: 0 auto!important;
              }

              div {
                margin: 0 auto;
                margin-top: 3%;
                h4 {
                  font-size: 28px;
                  color: #217a73;
                  font-weight: 400;
                }

                p {
                  color: #8a8a8a;
                  max-width: 500px;
                  font-size: 20px;
                  line-height: 1.4;
                  margin-top: 20px;
                  margin: 0 auto;

                }
              }
            }

            li:nth-child(2n) {
              display: flex;
              flex-direction: column;
              margin: 0 auto;
              justify-content: center;
              text-align: center;
              img {
              margin: 0 auto;
              }
              div {
                margin: 0 auto;
                margin-top: 3%;
                
              }
            }
            li:nth-child(3) {
              margin-top: 50px;
              div {
              margin: 0 auto;margin-top: 20px;}
            }
            li:nth-child(1):after {
              display: none;
              content: "";
              background-image: url("../assets/images/Group 1580.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: -30%;
              left: 40%;
              width: 200px;
              height: 200px;
            }

            li:nth-child(2):after {
              display: none;
              content: "";
              background-image: url("../assets/images/Group 1582.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: -80%;
              right: 5%;
              width: 750px;
              height: 400px;
            }

            li:nth-child(3):after {
              display: none;
              content: "";
              background-image: url("../assets/images/Group 1583.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: -30%;
              right: 15%;
              width: 300px;
              height: 300px;
            }

            li:nth-child(3):before {
              display: none;
              content: "";
              background-image: url("../assets/images/Group 1584.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: 80%;
              right: 7%;
              width: 450px;
              height: 400px;
            }
          }

          a {
            color: #fff;
            font-size: 16px;
            background-color: #49d6cb;
            padding: 15px 50px;
            border-radius: 10px;
            margin-left: 35%;
          }
        }
      }
    }

    .texnologySection {
      .texnologyWrapper {
        .texnologyBody {
          margin-top: 50px;

          h3 {
            font-size: 30px;
            color: #217a73;
            text-align: center;
            font-weight: 500;
            position: relative;

          }

          p {
            color: #7d7d7d;
            font-size: 16px;
            max-width: 520px;
            margin: 0 auto;
            line-height: 25px;
            padding: 20px 0;
          }

          h3:before {
            display: none;
            content: "";
            background-image: url("../assets/images/servis_bacground.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            width: 200px;
            left: 0;
            top: 20px;
            height: 200px;
            z-index: -2;
          }

          ul {
            display: flex;
            flex-wrap: wrap;

            li {
              width: 70px;
              height: 80px;
              margin: 5px;
              border-radius: 5px;
              background-color: #fff;

              img {
                margin-left: 25%;
                margin-top: 10px;
                width: 30px;
              }

              p {
                font-size: 10px;
                color: #fff;
                margin-top: -10px;
                text-align: center;
              }
            }

            li:hover {
              box-shadow: 0px 0px 15px 5px rgba(0, 0, 0, 0.1607843137254902);

              p {
                color: #000;
              }
            }
          }
        }
      }
    }

    .sliderSection {
      background-color: #f4f6fc;
      margin-top: 65px;
      height: 500px;
    }
  }

  @media only screen and (max-width: 510px) {
    .container {
      width: 500px;
    }

    .heroSection {
    background-image: url("../assets/images/img_bacground_4.png"), url("../assets/images/img_bacground_1.png");
    background-size: 570px, 1030px;
    background-image: none;
    background-repeat: no-repeat;
    background-position: top left, top right;
    margin-top: -90px;

    .heroWrapper {
      padding-top: 0px;
      padding-bottom: 54px;

      .heroBody {
        margin-top: 150px;
        display: flex;
        padding: 0 10px;
        justify-content: space-between;
        flex-direction: column-reverse;
        div {
          h1 {
            font-size: 30px;
            line-height: 30px;
            font-family: "HelveticaNeueCyr";
            font-weight: 600;
            max-width: 250px;
            position: relative;
            margin-left: 10px;
            margin: 0 auto;
            margin-top: 9.5%;
          }

          h1::before {
            content: "";
            display: none;
            background-image: url("../assets/images/dots_hero.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            left: -16.5%;
            top: 30%;
            width: 90px;
            height: 77px;
          }

          h1::after {
            content: "";
            display: none;
            background-image: url("../assets/images/bacground_hero_2.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            width: 100px;
            height: 100px;
            top: -50%;
            left: 40%;
            z-index: -1;
          }

          p {
            max-width: 750px;
            font-size: 18px;
            margin-left: 10px;
            line-height: 20px;
            margin: 0 auto;
            margin-top: 12px;
          }
        }

        div {
          img:nth-child(2) {
            position: fixed;
            bottom: 10.4%;
            right: 5.35%;
            width: 48px;
            height: 48px;
            z-index: 5000;
            animation: animateCallImg 7s;
            animation-iteration-count: infinite;
          }
          img:nth-child(1) {
            width: 300px;
            margin: 0 auto;
            margin-top: 10px;
          }
        }

      }
    }
    }

    .pixyzEasysection {
      background-image: url("../assets/images/img_bacground_3.png"), url("../assets/images/img_bacground_2.png");
      background-size: 600px, 600px;
      background-image: none;
      background-repeat: no-repeat;
      background-position: top left, top right;
      padding: 0px;

      .pixyzEasywrapper {
        .pixyzEasybody {
          text-align: center;
          padding-top: 50px;
          h1 {
            font-size: 20px;
            color: #217a73;
            padding-bottom: 20px;
            text-align: center;
            margin: 0 auto;
          }

          p {
            font-size: 12px;
            color: #8a8a8a;
            max-width: 90%;
            margin: 0 auto;
            line-height: 1.5;
            padding-bottom: 220px;
            position: relative;
            text-align: center;
          }

          p::before {
            content: "";
            background-image: url("../assets/images/Component 2 – 1.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            top: 45%;
            left: 30%;
            width: 240px;
            height: 240px;
          }
          
        }
      }
    }

    .servicessection {
      background-color: #f4f6fc;
      margin-top: -65px;

      .serviceswrapper {
        .servicesbody {
          text-align: center;
          padding-top: 50px;

          h3 {
            font-size: 30px;
            color: #217a73;
            font-weight: 400;
            text-align: center;
          }

          p {
            color: #7d7d7d;
            max-width: 90%;
            line-height: 1.5;
            margin: 0 auto;
            font-size: 14px;
            padding-top: 20px;
          }



          ul::before {
            content: "";
            background-image: url("../assets/images/servis_bacground.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            bottom: -5%;
            right: 8%;
            width: 150px;
            height: 150px;
          }

          div {
            img {
              margin-bottom: -50px;
            }
          }
        }
      }
    }

    .postUserSection {
      .postUserWrapper {
        .postUserBody {
          margin: 0 auto;
          -webkit-box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.160784);
          box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.160784);
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          margin-top: 80px;

          .post_user_left {
            width: 100%;
            padding: 20px;

            h3 {
              color: #217a73;
              font-size: 28px;
              padding: 10px 0;
            }

            form {
              display: -webkit-box;
              display: -ms-flexbox;
              display: flex;
              -ms-flex-wrap: wrap;
              justify-content: center;
              flex-wrap: wrap;
              width: 100%;
              margin: 0;
              input {
                margin: 10px;
                padding: 15px;
                width: 90%;
                border: none;
                border: 1px solid #49d6cb !important;
                color: #c9c9c9 !important;
              }

              select {
                padding: 15px;
                width: 90%;
                color: #c9c9c9;
                margin: 10px;
                border: none;
                border: 1px solid #49d6cb;
                background-color: inherit !important;
              }

              textarea {
                width: 90%;
                margin: 10px;
                padding: 15px;
                text-align: left;
                border: none;
                color: #c9c9c9;
                border: 1px solid #49d6cb;
                background-color: inherit !important;
                resize: none;
              }

              button {
                background-color: #49d6cb;
                display: block;
                border: 1px solid #fff;
                padding: 15px 50px;
                color: #fff;
                margin: 10px;
                -webkit-transition: all 0.5s;
                transition: all 0.5s;
              }

              button:hover {
                background-color: #fff;
                color: #49d6cb;
                border: 1px solid #49d6cb;
              }
            }
          }

          .post_user_right {
            display: none;
            background-image: url("../assets/images/img_post.png");
            background-position: bottom right;
            background-repeat: no-repeat;
            background-size: 200px;
            background-color: #49d6cb;
            width: 420px;
            padding-left: 30px;

            h3 {
              color: #fff;
              font-size: 32px;
              font-weight: 600;
              margin-top: 45px;
            }

            a {
              display: block;
              color: #fff;
              font-size: 16px;
              font-weight: normal;
              margin-top: 45px;
            }
          }

        }
      }
    }

    .workLineSection {
      .workLineWrapper {
        .workLineBody {
          margin-top: 100px;

          h3 {
            text-align: center;
            font-size: 40px;
            color: #217a73;
            font-weight: 400;
          }

          ul {
            margin: 0!important;
            padding: 0!important;
            li {
              display: flex;
              position: relative;
              flex-direction: column;
              justify-content: center;
              margin: 100px 0;
              text-align: center;
              padding: 0!important;
              img {
                width: 60%!important;
                height: auto;
                margin: 0 auto!important;
              }

              div {
                margin: 0 auto;
                margin-top: 3%;
                h4 {
                  font-size: 28px;
                  color: #217a73;
                  font-weight: 400;
                }

                p {
                  color: #8a8a8a;
                  max-width: 500px;
                  font-size: 20px;
                  line-height: 1.4;
                  margin-top: 20px;
                  margin: 0 auto;
                  margin-top: 20px;
                }
              }
            }

            li:nth-child(2n) {
              display: flex;
              flex-direction: column;
              margin: 0 auto;
              justify-content: center;
              text-align: center;
              img {
              margin: 0 auto;
              }
              div {
                margin: 0 auto;
                margin-top: 3%;
                
              }
            }
            li:nth-child(3) {
              margin-top: 50px;
              img {
                width: 240px!important;
              }
              div {
                margin: 0 auto;
                margin-top: 20px;
              }
            }
            li:nth-child(1):after {
              display: none;
              content: "";
              background-image: url("../assets/images/Group 1580.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: -30%;
              left: 40%;
              width: 200px;
              height: 200px;
            }

            li:nth-child(2):after {
              display: none;
              content: "";
              background-image: url("../assets/images/Group 1582.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: -80%;
              right: 5%;
              width: 750px;
              height: 400px;
            }

            li:nth-child(3):after {
              display: none;
              content: "";
              background-image: url("../assets/images/Group 1583.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: -30%;
              right: 15%;
              width: 300px;
              height: 300px;
            }

            li:nth-child(3):before {
              display: none;
              content: "";
              background-image: url("../assets/images/Group 1584.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: 80%;
              right: 7%;
              width: 450px;
              height: 400px;
            }
          }

          a {
            color: #fff;
            font-size: 16px;
            background-color: #49d6cb;
            padding: 15px 50px;
            border-radius: 10px;
            margin-left: 30%;
          }
        }
      }
    }

    .texnologySection {
    .texnologyWrapper {
      .texnologyBody {
        margin-top: 75px;

        h3 {
          font-size: 28px;
          color: #217a73;
          text-align: center;
          position: relative;
          font-family: 'HelveticaNeueCyr';
          font-weight: bold;
          letter-spacing: -0.1px;
          margin-left: 0px;
        }

        p {
          color: #7d7d7d;
          font-size: 16px;
          max-width: 1410px;
          margin: 0 auto;
          padding: 52px 0px;
          padding-left: 10px;
          line-height: 24px;
          margin-top: -30px;
          text-align: center;
        }

        h3:before {
          content: "";
          background-image: url("../assets/images/servis_bacground.png");
          position: absolute;
          background-size: contain;
          display: none;
          background-repeat: no-repeat;
          width: 280px;
          left: 10.5%;
          top: 30px;
          height: 280px;
          z-index: -2;
        }

        ul {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          padding-left: 0px;
          margin-top: -10px;
          margin-bottom: 7px;
          li {
            width: 70px;
            height: 90px;
            margin: 8px 10px;
            border-radius: 5px;
            background-color: #fff;
            border: 1px solid transparent;
            position: relative;
            img {
                display: block;
                margin: 0 auto; 
                margin-top: 13px;             
            }

            p {
              font-size: 10px;
              color: #fff;
              text-align: center;
              position: absolute;
              bottom: -40px;
              left: -5px;
            }

            transition: all 0.5s;
          }

          li:hover {
            box-shadow: 0px 0px 15px 5px rgba(0, 0, 0, 0.1607843137254902);
            border: 1px solid rgba(0, 0, 0, 0.1607843137254902);
            cursor: pointer;
            p {
              color: #000;
            }
          }
        }
      }
    }
    }

    .sliderSection {
      background-color: #f4f6fc;
      margin-top: 65px;
      height: 500px;
    }
  }

  @media only screen and (max-width: 450px) {
    .container {
      width: 90%;
    }

     .heroSection {
    background-image: url("../assets/images/img_bacground_4.png"), url("../assets/images/img_bacground_1.png");
    background-size: 570px, 1030px;
    background-image: none;
    background-repeat: no-repeat;
    background-position: top left, top right;
    margin-top: -90px;

    .heroWrapper {
      padding-top: 0px;
      padding-bottom: 54px;

      .heroBody {
        margin-top: 150px;
        display: flex;
        padding: 0 10px;
        justify-content: space-between;
        flex-direction: column-reverse;
        div {
          h1 {
            font-size: 25px;
            line-height: 30px;
            font-family: "HelveticaNeueCyr";
            font-weight: 600;
            max-width: 220px;
            position: relative;
            margin-left: 10px;
            margin: 0 auto;
            margin-top: 9.5%;
          }

          h1::before {
            content: "";
            display: none;
            background-image: url("../assets/images/dots_hero.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            left: -16.5%;
            top: 30%;
            width: 90px;
            height: 77px;
          }

          h1::after {
            content: "";
            display: none;
            background-image: url("../assets/images/bacground_hero_2.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            width: 100px;
            height: 100px;
            top: -50%;
            left: 40%;
            z-index: -1;
          }

          p {
            max-width: 750px;
            font-size: 14px;
            margin-left: 10px;
            line-height: 20px;
            margin: 0 auto;
            margin-top: 12px;
          }
        }

        div {
          img:nth-child(2) {
            position: fixed;
            bottom: 10.4%;
            right: 5.35%;
            width: 48px;
            height: 48px;
            z-index: 5000;
            animation: animateCallImg 7s;
            animation-iteration-count: infinite;
          }
          img:nth-child(1) {
            width: 90%;
            margin: 0 auto;
            margin-top: 10px;
          }
        }

      }
    }
    }

    .pixyzEasysection {
      background-image: url("../assets/images/img_bacground_3.png"), url("../assets/images/img_bacground_2.png");
      background-size: 600px, 600px;
      background-image: none;
      background-repeat: no-repeat;
      background-position: top left, top right;
      padding: 0px;

      .pixyzEasywrapper {
        .pixyzEasybody {
          text-align: center;
          padding-top: 0px;

          h1 {
            font-size: 13px;
            color: #217a73;
            padding-bottom: 20px;
            max-width: 90%;
            margin: 0 auto;
          }

          p {
            font-size: 8px;
            color: #8a8a8a;
            max-width: 80%;
            margin: 0 auto;
            line-height: 1.5;
            padding-bottom: 20px;
            position: relative;
          }

          p::before {
            display: none;
            content: "";
            background-image: url("../assets/images/Component 2 – 1.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            top: 30%;
            left: 40%;
            width: 300px;
            height: 300px;
          }
        }
      }
    }

    .servicessection {
      background-color: #f4f6fc;
      margin-top: -0px;

      .serviceswrapper {
        .servicesbody {
          text-align: center;
          padding-top: 30px;

          h3 {
            font-size: 20px;
            color: #217a73;
            font-weight: 400;
          }

          p {
            color: #7d7d7d;
            max-width: 350px;
            line-height: 1.5;
            margin: 0 auto;
            font-size: 10px;
            padding-top: 20px;
          }


          ul::before {
            content: "";
            display: none;
            background-image: url("../assets/images/servis_bacground.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            bottom: -10%;
            right: 8%;
            width: 200px;
            height: 200px;
          }

          div {
            img {
              margin-bottom: -50px;
            }
          }
        }
      }
    }

    .postUserSection {
      .postUserWrapper {
        .postUserBody {
          margin: 0 auto;
          -webkit-box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.160784);
          box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.160784);
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          margin-top: 80px;

          .post_user_left {
            width: 100%;
            padding: 20px;

            h3 {
              color: #217a73;
              font-size: 28px;
              padding: 10px 0;
            }

            form {
              display: -webkit-box;
              display: -ms-flexbox;
              display: flex;
              -ms-flex-wrap: wrap;
              flex-wrap: wrap;
              
              input {
                margin: 10px;
                padding: 15px;
                width: 320px;
                border: none;
                border: 1px solid #49d6cb !important;
                color: #c9c9c9 !important;
              }

              select {
                padding: 15px;
                width: 320px;
                color: #c9c9c9;
                margin: 10px;
                border: none;
                border: 1px solid #49d6cb;
                background-color: inherit !important;
              }

              textarea {
                width: 320px;
                margin: 10px;
                padding: 15px;
                text-align: left;
                border: none;
                color: #c9c9c9;
                border: 1px solid #49d6cb;
                background-color: inherit !important;
                resize: none;
              }

              button {
                background-color: #49d6cb;
                display: block;
                border: 1px solid #fff;
                padding: 15px 50px;
                width: 88%;
                color: #fff;
                margin: 10px;
                -webkit-transition: all 0.5s;
                transition: all 0.5s;
              }

              button:hover {
                background-color: #fff;
                color: #49d6cb;
                border: 1px solid #49d6cb;
              }
            }
          }

          .post_user_right {
            display: none;
            background-image: url("../assets/images/img_post.png");
            background-position: bottom right;
            background-repeat: no-repeat;
            background-size: 200px;
            background-color: #49d6cb;
            width: 420px;
            padding-left: 30px;

            h3 {
              color: #fff;
              font-size: 32px;
              font-weight: 600;
              margin-top: 45px;
            }

            a {
              display: block;
              color: #fff;
              font-size: 16px;
              font-weight: normal;
              margin-top: 45px;
            }
          }

        }
      }
    }

    .workLineSection {
      .workLineWrapper {
        .workLineBody {
          margin-top: 70px;
          h3 {
            text-align: center;
            font-size: 30px;
            color: #217a73;
            font-weight: 400;
          }

          ul {
            li {
              display: flex;
              position: relative;
              flex-direction: column;
              justify-content: center;
              margin: 50px 0;
              padding: 0 40px;
              text-align: center;

              img {
                width: 250px;
                margin: 0 auto;
              }

              div {
                margin-top: 5%;

                h4 {
                  font-size: 20px;
                  color: #217a73;
                  font-weight: 400;
                }

                p {
                  color: #8a8a8a;
                  max-width: 500px;
                  font-size: 13px;
                  line-height: 1.4;
                  margin-top: 20px;
                  margin: 0 auto;
                  padding: 10px 0;
                }
              }
            }

            li:nth-child(2n) {
              display: flex;
              flex-direction: column;
            }

            li:nth-child(2) {
              display: flex;
              flex-direction: column;
              margin: 40px;
              img {
                height: auto;
                width: 200px!important;
              }
              div {
                margin: 0 auto;
                text-align: center;
                margin-top: 5%;
            
                h4 {
                  font-size: 20px;
                  color: #217a73;
                  font-weight: 400;
                }

                p {
                  color: #8a8a8a;
                  max-width: 400px!important;
                  font-size: 13px;
                  line-height: 1.4;
                  margin-top: 20px;
                  margin: 0 auto;
                  padding: 10px 0;
                }
              }
            }
            li:nth-child(3) {
              display: flex;
              flex-direction: column;
              margin: 0 auto;
                margin-left: 0px;

              img {
              margin: 10px auto;}
             div {
                margin: 0 auto;
                text-align: center;
                margin-top: 5%;
            
                h4 {
                  font-size: 20px;
                  color: #217a73;
                  font-weight: 400;
                }

                p {
                  color: #8a8a8a;
                  max-width: 400px!important;
                  font-size: 13px;
                  line-height: 1.4;
                  margin-top: 20px;
                  margin: 0 auto;
                  padding: 10px 0;
                }
              }
            }
            li:nth-child(1):after {
              display: none;
              content: "";
              background-image: url("../assets/images/Group 1580.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: -30%;
              left: 40%;
              width: 200px;
              height: 200px;
            }

            li:nth-child(2):after {
              display: none;
              content: "";
              background-image: url("../assets/images/Group 1582.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: -80%;
              right: 5%;
              width: 750px;
              height: 400px;
            }

            li:nth-child(3):after {
              display: none;
              content: "";
              background-image: url("../assets/images/Group 1583.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: -30%;
              right: 15%;
              width: 300px;
              height: 300px;
            }

            li:nth-child(3):before {
              display: none;
              content: "";
              background-image: url("../assets/images/Group 1584.png");
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              top: 80%;
              right: 7%;
              width: 450px;
              height: 400px;
            }
          }

          a {
            color: #fff;
            font-size: 12px;
            background-color: #49d6cb;
            padding: 10px 30px;
            border-radius: 10px;
            margin-top: 40px;
            margin-left: 30%;
          }
        }
      }
    }

    .texnologySection {
      .texnologyWrapper {
        .texnologyBody {
          margin-top: 50px;

          h3 {
            font-size: 25px;
            color: #217a73;
            text-align: center;
            font-weight: 500;
            position: relative;

          }

          p {
            color: #7d7d7d;
            font-size: 11px;
            line-height: 17px;
            max-width: 1400px;
            margin: 0 auto;
            padding: 20px 0;
          }

          h3:before {
            display: none;
            content: "";
            background-image: url("../assets/images/servis_bacground.png");
            position: absolute;
            background-size: contain;
            background-repeat: no-repeat;
            width: 200px;
            left: 0;
            top: 20px;
            height: 200px;
            z-index: -2;
          }

          ul {
            display: flex;
            flex-wrap: wrap;

            li {
              width: 70px;
              height: 90px;
              margin: 5px;
              border-radius: 5px;
              background-color: #fff;

              img {
                margin-left: 25%;
                margin-top: 10px;
                width: 30px;
              }

              p {
                font-size: 8px;
                color: #fff;
                margin-top: 0px;
                bottom: -13px;
                margin-left: 10px;
                text-align: center;
              }
            }
            li:nth-child(2n) {
              display: none;
            }
            li:hover {
              box-shadow: 0px 0px 15px 5px rgba(0, 0, 0, 0.1607843137254902);

              p {
                color: #000;
              }
            }
          }
        }
      }
    }

    .sliderSection {
      background-color: #f4f6fc;
      height: 400px;
    }
  }

</style>